/* ============================================================
   K-home Design System - Interaktionen (vanilla JS, keine Deps)
   Header/Mega-Menü, Mobile-Nav, Suche, Cart-Drawer (AJAX),
   Mengen-Stepper, Tabs, Accordion, PDP-Varianten-Logik,
   Sticky-ATC, Kategorie-Filter (client-side), Cross-Selling.
   ============================================================ */
(function () {
  'use strict';

  var routes = window.KH_ROUTES || {
    cart_add_url: '/cart/add',
    cart_change_url: '/cart/change',
    cart_url: '/cart',
    root_url: '/',
  };

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatEuro(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' Euro';
  }

  /* ---------- Cart-Drawer ---------- */
  var Drawer = {
    el: null,
    init: function () {
      this.el = qs('#KhCartDrawer');
      if (!this.el) return;
      var self = this;
      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-kh-open-cart]');
        if (opener) { e.preventDefault(); self.open(); return; }
        var closer = e.target.closest('[data-kh-close-cart]');
        if (closer && self.el.contains(closer)) { e.preventDefault(); self.close(); return; }
        if (e.target.classList && e.target.classList.contains('kh-drawer__overlay') && self.el.contains(e.target)) self.close();
        var removeBtn = e.target.closest('[data-kh-remove-line]');
        if (removeBtn) { e.preventDefault(); self.changeLine(parseInt(removeBtn.getAttribute('data-kh-remove-line'), 10), 0); }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.el.classList.contains('is-open')) self.close();
      });
    },
    open: function () {
      if (!this.el) return;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    },
    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    },
    replaceFromSectionHtml: function (html) {
      if (!this.el || !html) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector('#KhCartDrawer');
      if (!fresh) return;
      var wasOpen = this.el.classList.contains('is-open');
      var panelFresh = fresh.querySelector('.kh-drawer__panel');
      var panelOld = this.el.querySelector('.kh-drawer__panel');
      if (panelFresh && panelOld) {
        panelOld.innerHTML = panelFresh.innerHTML;
      } else {
        this.el.innerHTML = fresh.innerHTML;
      }
      if (wasOpen) this.open();
    },
    setBusy: function (busy) {
      if (this.el) this.el.setAttribute('aria-busy', busy ? 'true' : 'false');
    },
    changeLine: function (line, qty) {
      var self = this;
      self.setBusy(true);
      fetch(routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty, sections: 'kh-cart-drawer' }),
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          if (cart.sections && cart.sections['kh-cart-drawer']) self.replaceFromSectionHtml(cart.sections['kh-cart-drawer']);
          khPruefeKuerzservice(cart);
          // Backlog 126: der Drawer hat seine Änderung bisher niemandem
          // gesagt. Wer hier eine Zeile entfernt, ändert damit auch, was
          // andernorts noch erlaubt ist, etwa die Mengengrenze am Lager und
          // die Zahl der Stoffmuster. Am 21.09.2026 im Browser gemessen: ein
          // entferntes Muster liess alle 137 Knoepfe gesperrt stehen, bis die
          // Seite neu geladen wurde.
          document.dispatchEvent(new CustomEvent('kh:warenkorb'));
        })
        .catch(function () { window.location.href = routes.cart_url; })
        .then(function () { self.setBusy(false); });
    },
  };

  function updateCartCount(count) {
    qsa('[data-kh-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', String(count));
    });
  }

  /* Block 6: Meldung als kleines Banner unten, für Vorgänge, die der Kunde
     nicht selbst ausgelöst hat, etwa den entfernten verwaisten Kürzservice. */
  function khMeldung(text) {
    var alt = document.querySelector('.kh-meldung');
    if (alt) alt.remove();
    var box = document.createElement('div');
    box.className = 'kh-meldung';
    box.setAttribute('role', 'status');
    var span = document.createElement('span');
    span.textContent = text;
    box.appendChild(span);
    var zu = document.createElement('button');
    zu.type = 'button';
    zu.className = 'kh-meldung__zu';
    zu.setAttribute('aria-label', 'Meldung schließen');
    zu.textContent = '×';
    zu.addEventListener('click', function () { box.remove(); });
    box.appendChild(zu);
    document.body.appendChild(box);
    setTimeout(function () { if (box.parentNode) box.remove(); }, 10000);
  }

  /* Block 6, der Wächter: Shopify koppelt Warenkorbpositionen nicht. Ein
     Kürzservice, der über den Direkt-Add mit _kh_fuer an eine Plissee-
     Variante gebunden wurde, fliegt sichtbar begründet raus, sobald diese
     Variante nicht mehr im Warenkorb liegt. Von Hand hinzugefügte Services
     ohne Bindung bleiben unangetastet, dieser Weg existiert weiter. */
  function khPruefeKuerzservice(cart) {
    if (!cart || !cart.items) return Promise.resolve(0);
    var vorhanden = {};
    cart.items.forEach(function (i) { vorhanden[i.variant_id] = true; });
    var waisen = cart.items.filter(function (i) {
      var bezugVid = i.properties && i.properties['_kh_fuer'];
      return bezugVid && !vorhanden[parseInt(bezugVid, 10)];
    });
    if (!waisen.length) return Promise.resolve(0);
    var kette = Promise.resolve();
    waisen.forEach(function (i) {
      kette = kette.then(function () {
        return fetch(routes.cart_change_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: i.key, quantity: 0, sections: 'kh-cart-drawer' })
        }).then(function (r) { return r.json(); }).then(function (c) {
          updateCartCount(c.item_count);
          if (c.sections && c.sections['kh-cart-drawer']) Drawer.replaceFromSectionHtml(c.sections['kh-cart-drawer']);
        });
      });
    });
    return kette.then(function () {
      khMeldung('Der Kürzservice wurde aus dem Warenkorb entfernt, weil das zugehörige Plissee nicht mehr darin liegt.');
      return waisen.length;
    });
  }
  window.khPruefeKuerzservice = khPruefeKuerzservice;

  /* ---------- Bestandsgrenze der Mengenwahl ---------- */
  // Die Obergrenze ist der Lagerbestand minus dem, was von derselben Variante
  // schon im Warenkorb liegt. Ohne diesen Abzug ließe sich die Grenze umgehen,
  // indem man zweimal hintereinander die volle Menge einlegt. Shopify weist das
  // an der Kasse ohnehin ab, nur erfährt der Kunde es dann erst dort.
  var khWarenkorb = { zeilen: null };

  function ladeWarenkorbstand() {
    if (typeof fetch !== 'function') return Promise.resolve(null);
    return fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        khWarenkorb.zeilen = j ? (j.items || []) : null;
        if (j) khPruefeKuerzservice(j);
        return khWarenkorb.zeilen;
      })
      .catch(function () { return null; });
  }

  function mengeImWarenkorb(variantId) {
    if (!khWarenkorb.zeilen || !variantId) return 0;
    var n = 0;
    khWarenkorb.zeilen.forEach(function (z) {
      if (String(z.id) === String(variantId)) n += z.quantity;
    });
    return n;
  }

  /* ---------- Kostenlose Stoffmuster (Backlog 126) ---------- */
  // Der Produkttyp ist die eine Kennzeichnung, an der ein Muster im Warenkorb
  // erkannt wird. Er steht in /cart.js an jeder Zeile. Die SKU dient nur als
  // Rückfall: ein von Hand im Admin umgetippter Produkttyp soll die Grenze
  // nicht aushebeln, und ein stiller Ausfall wäre hier teuer, weil dann jede
  // Menge Muster in einen Karton ginge.
  var MUSTER_TYP = 'Stoffmuster';
  var MUSTER_SKU_PRAEFIX = 'MUSTER-';
  var MUSTER_STANDARD_GRENZE = 5;

  function istMusterZeile(z) {
    if (!z) return false;
    if (z.product_type === MUSTER_TYP) return true;
    return typeof z.sku === 'string' && z.sku.indexOf(MUSTER_SKU_PRAEFIX) === 0;
  }

  // Die Grenze steht im Markup der Stoffmuster-Seite und kommt dort aus der
  // Theme-Einstellung. Auf der Produktseite gibt es sie nicht, deshalb der
  // Standardwert. Eine zweite hart verdrahtete Zahl wäre genau die Sorte
  // Doppelpflege, die hier schon einmal auseinandergelaufen ist.
  function musterGrenze() {
    var seite = qs('[data-kh-stoffmuster]');
    var roh = seite && parseInt(seite.getAttribute('data-max'), 10);
    return (roh && roh > 0) ? roh : MUSTER_STANDARD_GRENZE;
  }

  // Liefert Anzahl und die belegten Varianten-IDs. Gezählt wird die Menge je
  // Zeile, nicht die Zahl der Zeilen: zwei Stück derselben Farbe sind zwei
  // Muster, auch wenn Shopify sie in einer Zeile führt.
  function musterStand() {
    var stand = { anzahl: 0, ids: {} };
    if (!khWarenkorb.zeilen) return stand;
    khWarenkorb.zeilen.forEach(function (z) {
      if (!istMusterZeile(z)) return;
      stand.anzahl += z.quantity;
      stand.ids[String(z.id)] = (stand.ids[String(z.id)] || 0) + z.quantity;
    });
    return stand;
  }

  // Ein Ereignis statt eines direkten Aufrufs, damit Produktseite und
  // Stoffmuster-Seite dieselbe Meldung hören, ohne voneinander zu wissen.
  function meldeMusterstand() {
    document.dispatchEvent(new CustomEvent('kh:musterstand', { detail: musterStand() }));
  }

  /* Legt genau ein Muster in den Warenkorb. Die Grenze wird VOR dem Aufruf
     geprüft und danach noch einmal aus dem frischen Warenkorb bestätigt.

     Was das hier bewusst NICHT ist: eine Absicherung gegen Missbrauch. Die
     Grenze liegt im Theme und nicht im Checkout, wer den Warenkorb über die
     URL befüllt, kommt daran vorbei. Bei einem kostenlosen Muster ohne
     Bestandsführung ist der Schaden ein Portobetrag; der harte Weg wäre eine
     Shopify Function zur Warenkorbprüfung, und die steht dazu nicht im
     Verhältnis. Wird Missbrauch sichtbar, ist das der nächste Schritt. */
  function musterAdd(variantId, stoff, farbe, quelle) {
    if (!variantId) return Promise.resolve(false);
    var grenze = musterGrenze();
    var stand = musterStand();
    if (stand.ids[String(variantId)]) {
      khMeldung('Dieses Muster liegt bereits in Ihrem Warenkorb.');
      return Promise.resolve(false);
    }
    if (stand.anzahl >= grenze) {
      khMeldung('Mehr als ' + grenze + ' Muster gehen nicht in eine Bestellung. Nehmen Sie eines heraus, wenn Sie ein anderes möchten.');
      // Die abgewiesene Anfrage ist das einzige Signal dafür, ob die Grenze zu eng
      // sitzt. Ohne sie sieht man nur, was durchging, nie was jemand wollte.
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'stoffmuster_limit', {
          kh_product_id: stoff || '',
          kh_color: farbe || '',
          kh_quelle: quelle || 'seite',
          kh_muster_anzahl: stand.anzahl
        });
      }
      return Promise.resolve(false);
    }
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: 'kh-cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) {
          khMeldung(data.description || 'Das hat leider nicht geklappt.');
          return false;
        }
        if (data.sections && data.sections['kh-cart-drawer']) Drawer.replaceFromSectionHtml(data.sections['kh-cart-drawer']);
        return ladeWarenkorbstand().then(function () {
          var frisch = musterStand();
          updateCartCount((khWarenkorb.zeilen || []).reduce(function (n, z) { return n + z.quantity; }, 0));
          Drawer.open();
          // Reihenfolge: erst das allgemeine Ereignis, dann die eigene
          // Meldung. Der Zuhörer oben liest auf kh:warenkorb neu und würde
          // eine vorher gesetzte Anzeige sonst kurz überschreiben.
          document.dispatchEvent(new CustomEvent('kh:warenkorb'));
          meldeMusterstand();
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'stoffmuster_add', {
              kh_product_id: stoff || '',
              kh_color: farbe || '',
              kh_quelle: quelle || 'seite',
              kh_muster_anzahl: frisch.anzahl
            });
          }
          return true;
        });
      })
      .catch(function () { khMeldung('Das hat leider nicht geklappt. Bitte versuchen Sie es noch einmal.'); return false; });
  }

  // grund unterscheidet die beiden Fälle, die zu derselben Grenze führen:
  // 'lager' heisst, so viel ist einfach nicht da. 'warenkorb' heisst, der Rest
  // liegt bereits im Warenkorb. Für den Kunden ist das ein Unterschied.
  function zeigeMengenhinweis(box, max, grund, bestand) {
    var feld = box && box.closest('.kh-field');
    var hint = feld && feld.querySelector('[data-kh-qty-hint]');
    if (!hint) return;
    if (grund === 'warenkorb') {
      hint.textContent = bestand === 1
        ? 'Das eine verfügbare Stück liegt bereits in Ihrem Warenkorb.'
        : 'Alle ' + bestand + ' verfügbaren Stück liegen bereits in Ihrem Warenkorb.';
    } else {
      hint.textContent = max <= 0
        ? 'Diese Ausführung ist zurzeit nicht auf Lager.'
        : (max === 1
            ? 'Mehr als 1 Stück ist zurzeit nicht auf Lager.'
            : 'Mehr als ' + max + ' Stück sind zurzeit nicht auf Lager.');
    }
    hint.hidden = false;
    clearTimeout(hint._khTimer);
    hint._khTimer = setTimeout(function () { hint.hidden = true; }, 5000);
  }

  // Setzt den Wert einer Stepper-Box unter Beachtung von data-min und data-max
  // und hält die Knopfzustände nach. Rückgabe ist der wirklich gesetzte Wert.
  function stepperSetzen(box, wunsch, mitHinweis) {
    var input = box.querySelector('.kh-qty__value');
    if (!input) return null;
    var min = parseInt(input.getAttribute('data-min') || '1', 10);
    var max = parseInt(input.getAttribute('data-max') || '99', 10);
    if (isNaN(max)) max = 99;
    var wert = Math.max(min, Math.min(max, wunsch));
    if (mitHinweis && wunsch > max) {
      zeigeMengenhinweis(box, max, input.getAttribute('data-grund') || 'lager',
        parseInt(input.getAttribute('data-bestand') || '', 10));
    }
    if (input.tagName === 'INPUT') input.value = wert; else input.textContent = wert;
    box.querySelectorAll('.kh-qty__btn').forEach(function (b) {
      var isPlus = b.getAttribute('data-action') === 'plus';
      b.toggleAttribute('disabled', isPlus ? wert >= max : wert <= min);
    });
    return wert;
  }

  /* ---------- Add-to-Cart (alle Formulare mit data-kh-atc) ---------- */
  function initAtcForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-kh-atc]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.setAttribute('disabled', 'disabled'); btn.classList.add('kh-btn--busy'); }
      var fd = new FormData(form);
      fd.append('sections', 'kh-cart-drawer');
      fetch(routes.cart_add_url + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status && data.status !== 200) {
            // Shopify lehnt ab, wenn die Gesamtmenge den Bestand übersteigt.
            // Das sollte die Begrenzung am Mengenfeld vorher abfangen, hier
            // steht die Meldung an der Stelle, wo der Kunde gerade hinsieht.
            var qbox = form.querySelector('.kh-qty');
            var feld = qbox && qbox.closest('.kh-field');
            var hint = feld && feld.querySelector('[data-kh-qty-hint]');
            if (hint) {
              hint.textContent = data.description || 'Diese Menge ist zurzeit nicht auf Lager.';
              hint.hidden = false;
            }
            return ladeWarenkorbstand();
          }
          if (data.sections && data.sections['kh-cart-drawer']) Drawer.replaceFromSectionHtml(data.sections['kh-cart-drawer']);
          return fetch(routes.cart_url + '.js').then(function (r) { return r.json(); }).then(function (cart) {
            updateCartCount(cart.item_count);
            khWarenkorb.zeilen = cart.items || [];
            Drawer.open();
          });
        })
        .catch(function () { form.submit(); })
        .then(function () {
          if (btn) { btn.removeAttribute('disabled'); btn.classList.remove('kh-btn--busy'); }
          // Erst nach dem Freigeben melden, dass sich der Warenkorb geändert hat.
          // Sonst hebt die Freigabe oben eine Sperre wieder auf, die die
          // Bestandsgrenze gerade gesetzt hat.
          document.dispatchEvent(new CustomEvent('kh:warenkorb'));
        });
    });
  }

  /* ---------- Mengen-Stepper (Event-Delegation) ---------- */
  function initSteppers() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.kh-qty__btn');
      if (!btn) return;
      e.preventDefault();
      var box = btn.closest('.kh-qty');
      var input = box.querySelector('.kh-qty__value');
      var val = parseInt(input.value || input.textContent || '1', 10) || 1;
      var wunsch = btn.getAttribute('data-action') === 'plus' ? val + 1 : val - 1;
      var next = stepperSetzen(box, wunsch, true);
      if (next === null || next === val) return;
      var line = box.getAttribute('data-kh-line');
      if (line) Drawer.changeLine(parseInt(line, 10), next);
      var evt = new CustomEvent('kh:qty', { bubbles: true, detail: { value: next } });
      box.dispatchEvent(evt);
    });

    // Getippte Mengen begrenzen. Das Feld ist ein Textfeld, ohne diesen Zweig
    // ließe sich die Grenze mit der Tastatur übergehen.
    document.addEventListener('change', function (e) {
      var input = e.target.closest('input.kh-qty__value');
      if (!input) return;
      var box = input.closest('.kh-qty');
      if (!box) return;
      var roh = parseInt(String(input.value).replace(/[^0-9]/g, ''), 10);
      if (isNaN(roh) || roh < 1) roh = 1;
      var next = stepperSetzen(box, roh, true);
      if (next === null) return;
      var evt = new CustomEvent('kh:qty', { bubbles: true, detail: { value: next } });
      box.dispatchEvent(evt);
    });
  }

  /* ---------- Header: Mega-Menü, Mobile-Nav, Suche ---------- */
  function initHeader() {
    qsa('.kh-nav__item--mega').forEach(function (item) {
      var timer = null;
      item.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        qsa('.kh-nav__item--mega.is-open').forEach(function (o) { if (o !== item) o.classList.remove('is-open'); });
        item.classList.add('is-open');
      });
      item.addEventListener('mouseleave', function () {
        timer = setTimeout(function () { item.classList.remove('is-open'); }, 120);
      });
      var trigger = item.querySelector('.kh-nav__link');
      if (trigger) {
        trigger.addEventListener('focus', function () { item.classList.add('is-open'); });
      }
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) item.classList.remove('is-open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') qsa('.kh-nav__item--mega.is-open').forEach(function (o) { o.classList.remove('is-open'); });
    });

    var mnav = qs('#KhMobileNav');
    if (mnav) {
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-kh-open-menu]')) { e.preventDefault(); mnav.classList.add('is-open'); mnav.setAttribute('aria-hidden', 'false'); mnav.removeAttribute('inert'); document.documentElement.style.overflow = 'hidden'; }
        if (e.target.closest('[data-kh-close-menu]') || (e.target.classList && e.target.classList.contains('kh-mnav__overlay'))) {
          mnav.classList.remove('is-open'); mnav.setAttribute('aria-hidden', 'true'); mnav.setAttribute('inert', ''); document.documentElement.style.overflow = '';
        }
        var subBtn = e.target.closest('[data-kh-subtoggle]');
        if (subBtn) {
          e.preventDefault();
          var sub = subBtn.parentElement.querySelector('.kh-mnav__sub');
          if (sub) sub.classList.toggle('is-open');
          var chev = subBtn.querySelector('.kh-icon');
          if (chev) chev.style.transform = sub && sub.classList.contains('is-open') ? 'rotate(180deg)' : '';
        }
      });
    }

    var search = qs('#KhSearch');
    if (search) {
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-kh-toggle-search]')) {
          e.preventDefault();
          search.classList.toggle('is-open');
          if (search.classList.contains('is-open')) {
            var inp = search.querySelector('input[type="search"]');
            if (inp) inp.focus();
          }
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') search.classList.remove('is-open');
      });
    }
  }

  /* ---------- Tabs ---------- */
  function initTabs() {
    qsa('[data-kh-tabs]').forEach(function (wrap) {
      var tabs = qsa('.kh-tab', wrap);
      var panels = qsa('.kh-tabs__panel', wrap);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
          panels.forEach(function (p) {
            if (p.id === tab.getAttribute('aria-controls')) p.removeAttribute('hidden');
            else p.setAttribute('hidden', '');
          });
        });
      });
    });
    if (window.location.hash === '#reviews') {
      var revTab = qs('.kh-tab[data-tab-id="reviews"]');
      if (revTab) revTab.click();
    }
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href$="#reviews"]');
      if (!link) return;
      var revTab2 = qs('.kh-tab[data-tab-id="reviews"]');
      if (revTab2) {
        e.preventDefault();
        revTab2.click();
        var wrap = revTab2.closest('[data-kh-tabs]');
        if (wrap) wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  /* ---------- Accordion ---------- */
  function initAccordions() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.kh-acc__btn');
      if (!btn) return;
      var item = btn.closest('.kh-acc__item');
      var acc = btn.closest('.kh-acc');
      var multiple = acc.hasAttribute('data-multiple');
      var wasOpen = item.classList.contains('is-open');
      if (!multiple) qsa('.kh-acc__item.is-open', acc).forEach(function (i) { i.classList.remove('is-open'); i.querySelector('.kh-acc__btn').setAttribute('aria-expanded', 'false'); });
      item.classList.toggle('is-open', !wasOpen);
      btn.setAttribute('aria-expanded', String(!wasOpen));
    });
  }

  /* ---------- PDP: Varianten, Galerie, Sticky-ATC ---------- */
  function initPdp() {
    var root = qs('[data-kh-pdp]');
    if (!root) return;
    var dataEl = qs('#KhProductData');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var colorOptIndex = parseInt(root.getAttribute('data-color-index') || '-1', 10);
    var sizeOptIndex = parseInt(root.getAttribute('data-size-index') || '-1', 10);
    var swatchWrap = qs('[data-kh-swatches]', root);
    var swatchLabel = qs('[data-kh-swatch-label]', root);
    var sizeSelect = qs('[data-kh-size]', root);
    var idInputs = qsa('input[name="id"]', root);
    var idInput = idInputs[0] || null;
    var priceEl = qs('[data-kh-pdp-price]', root);
    var stockEl = qs('[data-kh-stock]', root);
    var atcBtns = qsa('[data-kh-pdp-atc]');
    var mainImg = qs('[data-kh-gallery-main] img', root);
    var galleryBlocks = { desktop: qs('.kh-gallery__thumbs', root), mobile: qs('.kh-gallery__mthumbs', root) };
    var satc = qs('#KhStickyAtc');

    function getColor() {
      var active = swatchWrap ? qs('.kh-swatch[aria-pressed="true"]', swatchWrap) : null;
      return active ? active.getAttribute('data-value') : null;
    }
    function getSize() { return sizeSelect ? sizeSelect.value : null; }

    /* Ohne Vorwahl sind Farbe oder Größe leer. Eine Variante gibt es erst,
       wenn beides gewählt ist; für Sperr-Prüfungen zählt eine leere Seite
       als "alles zugelassen", sonst wäre am Anfang jeder Knopf gesperrt. */
    function variantFor(color, size) {
      if (colorOptIndex >= 0 && !color) return undefined;
      if (sizeOptIndex >= 0 && !size) return undefined;
      return variants.find(function (v) {
        var okC = colorOptIndex < 0 || v.options[colorOptIndex] === color;
        var okS = sizeOptIndex < 0 || v.options[sizeOptIndex] === size;
        return okC && okS;
      });
    }
    /* Backlog 191: der Preis richtet sich nach dem, was schon gewählt ist. Kandidaten sind
       alle Varianten, die zur bisherigen Teilwahl passen (Farbe und/oder Größe). Haben alle
       denselben Preis, steht der Preis ohne "ab", sonst "ab" mit dem kleinsten Preis dieser
       Kandidaten. Ohne jede Wahl sind das alle Varianten, also der bisherige Ab-Preis. */
    function preisBild(v) {
      var c = getColor(), s = getSize();
      var kand = v ? [v] : variants.filter(function (x) {
        return (colorOptIndex < 0 || !c || x.options[colorOptIndex] === c) &&
               (sizeOptIndex < 0 || !s || x.options[sizeOptIndex] === s);
      });
      if (!kand.length) kand = variants;
      var minV = kand.reduce(function (m, x) { return (!m || x.price < m.price) ? x : m; }, null);
      var einheitlich = kand.every(function (x) { return x.price === minV.price; });
      var cmp = (minV && minV.compare_at_price && minV.compare_at_price > minV.price) ? minV.compare_at_price : null;
      return { preis: minV ? minV.price : minPreis, ab: !einheitlich, cmp: cmp };
    }
    function colorAvailable(color, size) {
      return variants.some(function (v) {
        return v.available && (colorOptIndex < 0 || v.options[colorOptIndex] === color) && (sizeOptIndex < 0 || !size || v.options[sizeOptIndex] === size);
      });
    }
    function buildColorThumbs(color) {
      if (!color || !mainImg) return;
      var galEl = document.getElementById('KhColorGallery');
      if (!window.__khGal) {
        try { window.__khGal = (JSON.parse(galEl ? galEl.textContent : '[]') || []).filter(Boolean); } catch (e) { window.__khGal = []; }
      }
      var items = window.__khGal.filter(function (g) { return g.c === color; });
      items.sort(function (a, b) { return (b.h ? 1 : 0) - (a.h ? 1 : 0); });
      var vimg = imageForColor(color);
      var hero = items[0] && items[0].h ? items[0] : null;
      var main = hero ? hero.u : (vimg || (items[0] ? items[0].u : null));
      if (!main) return;
      mainImg.src = main;
      mainImg.srcset = '';
      try { var khT = document.querySelector('.kh-buybox__title'); if (khT) mainImg.alt = khT.textContent.trim() + ' in ' + color; } catch (e) {}
      var list = [];
      function thumbOf(u) { return u ? u.replace('width=1400', 'width=140').replace('width=1200', 'width=140') : u; }
      // Am 02.08.2026 korrigiert. Der Schlüssel war der blanke Dateiname, und
      // damit hat die Entdoppelung zwei Schreibweisen derselben Datei nicht als
      // gleich erkannt: das Variantenbild kommt als "..._1400x.jpg", die
      // Farbgalerie als "....jpg" mit width-Parameter. Folge war, dass das
      // Hauptbild in Slot 1 und Slot 2 stand, auf 50 von 51 geprüften
      // Farb-Kombinationen, und dabei einen der fünf Plätze verbrauchte.
      // Die Transformendung wird jetzt abgeschnitten, Namen ohne diese Endung
      // bleiben unangetastet.
      function push(u, t) {
        if (!u) return;
        var key = u.split('?')[0].split('/').pop().replace(/_\d+x\d*(\.\w+)$/i, '$1');
        if (list.some(function (x) { return x.k === key; })) return;
        list.push({ k: key, u: u, t: t || thumbOf(u) });
      }
      push(main, hero ? hero.t : null);
      push(vimg, null);
      items.forEach(function (g) { push(g.u, g.t); });
      list = list.slice(0, 5);
      ['desktop', 'mobile'].forEach(function (key) {
        var blockEl = galleryBlocks[key];
        if (!blockEl) return;
        qsa('.kh-gallery__thumb', blockEl).forEach(function (t) { t.remove(); });
        list.forEach(function (g, idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'kh-gallery__thumb' + (idx === 0 ? ' is-active' : '');
          b.setAttribute('aria-label', 'Produktbild ' + color + ' ' + (idx + 1));
          var im = document.createElement('img');
          im.src = g.t;
          im.setAttribute('data-full', g.u);
          im.loading = 'lazy';
          im.alt = (function () { try { var t = document.querySelector('.kh-buybox__title'); return (t ? t.textContent.trim() : '') + ' in ' + color + ', Bild ' + (idx + 1); } catch (e) { return ''; } })();
          b.appendChild(im);
          blockEl.appendChild(b);
        });
      });
    }

    function imageForColor(color) {
      var withImg = variants.find(function (v) { return v.options[colorOptIndex] === color && v.image; });
      return withImg ? withImg.image : null;
    }

    function prettySize(val) {
      var m = /^(\d+(?:[.,]\d+)?)x(\d+(?:[.,]\d+)?)cm$/i.exec(val || '');
      if (!m) return val ? val.replace('x', ' x ').replace('cm', ' cm').replace(/\s+/g, ' ').trim() : val;
      return m[1] + ' x ' + m[2] + ' cm';
    }

    /* Größenauswahl als Knopfreihen. Der Select bleibt versteckter Zustandsträger,
       die Knöpfe werden aus der Variantenmatrix gebaut. Passt ein Größenwert nicht
       ins Muster HÖHExBREITEcm, werden keine Knöpfe gebaut und der Select bleibt
       sichtbar stehen, damit kein Produkt ohne Größenauswahl dasteht. */
    var sizepick = qs('[data-kh-sizepick]', root);
    var hrow = qs('[data-kh-hrow]', root);
    var brow = qs('[data-kh-brow]', root);
    var sizeGrid = null;

    function buildSizeGrid() {
      if (sizeOptIndex < 0) return null;
      var re = /^(\d+)x(\d+)cm$/i;
      var wbh = {}, seen = {}, kaputt = false;
      variants.forEach(function (v) {
        var val = String(v.options[sizeOptIndex] || '').trim();
        if (seen[val]) return;
        seen[val] = true;
        var m = re.exec(val);
        if (!m) { kaputt = true; return; }
        var h = +m[1], b = +m[2];
        if (!wbh[h]) wbh[h] = {};
        wbh[h][b] = val;
      });
      if (kaputt) return null;
      var heights = Object.keys(wbh).map(Number).sort(function (a, b) { return a - b; });
      if (!heights.length) return null;
      var widths = {};
      heights.forEach(function (h) {
        widths[h] = Object.keys(wbh[h]).map(Number).sort(function (a, b) { return a - b; });
      });
      return { heights: heights, widths: widths, val: wbh };
    }

    function currentSizeParsed() {
      var m = /^(\d+)x(\d+)cm$/i.exec(getSize() || '');
      return m ? { h: +m[1], b: +m[2] } : null;
    }

    function sizeExistsForColor(color, sizeVal) {
      return variants.some(function (v) {
        return (colorOptIndex < 0 || !color || v.options[colorOptIndex] === color) && v.options[sizeOptIndex] === sizeVal;
      });
    }

    function heightExistsForColor(color, h) {
      return sizeGrid.widths[h].some(function (b) {
        return sizeExistsForColor(color, sizeGrid.val[h][b]);
      });
    }

    function sizesForColor(color) {
      var list = [];
      variants.forEach(function (v) {
        if (colorOptIndex >= 0 && v.options[colorOptIndex] !== color) return;
        var val = v.options[sizeOptIndex];
        if (list.indexOf(val) === -1) list.push(val);
      });
      return list;
    }

    /* Gemeinsame Datenbasis für den Tooltip am Farbfeld und die Größen-
       Vorschläge aus Phase 3: welche Größen eine Farbe führt, nach Höhe
       gruppiert, samt der Lücken gegen das volle Raster des Produkts.
       Ohne Raster (Musterbruch in den Größenwerten) bleibt nur die flache
       Liste, dann sind byHeight und missing null. */
    function colorSizeInfo(color) {
      var have = {};
      sizesForColor(color).forEach(function (v) { have[v] = true; });
      if (!sizeGrid) {
        var flat = Object.keys(have);
        return { flat: flat, byHeight: null, missing: null, count: flat.length, total: null };
      }
      var byHeight = [], missing = [], count = 0, total = 0;
      sizeGrid.heights.forEach(function (h) {
        var widths = [], vals = [];
        sizeGrid.widths[h].forEach(function (b) {
          var val = sizeGrid.val[h][b];
          total++;
          if (have[val]) { widths.push(b); vals.push(val); count++; }
          else { missing.push(val); }
        });
        if (widths.length) byHeight.push({ h: h, widths: widths, vals: vals });
      });
      return { flat: null, byHeight: byHeight, missing: missing, count: count, total: total };
    }

    /* Tooltip-Text ohne Mengenschwelle. Vollständige Lagen werden zur Aussage
       "in allen Größen", fast vollständige umgedreht ("außer ..."), der Rest
       nach Höhe gruppiert ausgeschrieben, eine Zeile je Höhe. */
    function colorSizeText(color) {
      var info = colorSizeInfo(color);
      if (!info.count) return '';
      if (info.flat) {
        return ' Lieferbar in: ' + info.flat.map(prettySize).join(', ') + '.';
      }
      if (!info.missing.length) return ' Lieferbar in allen Größen.';
      if (info.missing.length <= 3) {
        var m = info.missing.map(prettySize);
        var letzte = m.pop();
        return ' Lieferbar in allen Größen außer ' + (m.length ? m.join(', ') + ' und ' : '') + letzte + '.';
      }
      var teile = info.byHeight.map(function (g) {
        return dim1Label() + ' ' + g.h + ': ' + g.widths.join(', ') + ' cm';
      });
      return ' Lieferbar in:\n' + teile.join('\n');
    }

    function applySizeValue(val) {
      if (!sizeSelect || sizeSelect.value === val) return;
      sizeSelect.value = val;
      sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var pendingH = null;

    function dim1Label() {
      return (sizepick && sizepick.getAttribute('data-dim1')) || 'Höhe';
    }

    // Zweite Achse. Bei Fensterware ist das die Breite, bei Badematten die Länge.
    // Der Wert kommt aus data-dim2 am Sizepick und wird im Liquid gesetzt. Vorher
    // stand hier das Wort Breite fest im Code, dadurch las der Kaufhinweis auf
    // einer Badematte "Bitte Breite und Breite wählen".
    function dim2Label() {
      return (sizepick && sizepick.getAttribute('data-dim2')) || 'Breite';
    }

    function syncSizeButtons() {
      if (!sizeGrid || !hrow || !brow) return;
      var color = getColor();
      var cur = currentSizeParsed();
      // Ohne gewählte Größe zählt die vorgemerkte Höhe. Gibt es auch die
      // nicht, bleibt die Breitenreihe ein Hinweis statt einer Knopfreihe.
      var curH = cur ? cur.h : pendingH;
      qsa('[data-kh-hbtn]', hrow).forEach(function (btn) {
        var h = +btn.getAttribute('data-kh-hbtn');
        var da = heightExistsForColor(color, h);
        var an = curH !== null && h === curH;
        btn.classList.toggle('is-active', an);
        btn.setAttribute('aria-pressed', an ? 'true' : 'false');
        btn.toggleAttribute('disabled', !da);
        btn.title = da ? dim1Label() + ' ' + h + ' cm' : dim1Label() + ' ' + h + ' cm gibt es nicht in ' + (color || 'dieser Farbe');
      });
      brow.innerHTML = '';
      if (curH === null || !sizeGrid.widths[curH]) {
        var hint = document.createElement('span');
        hint.className = 'kh-sizepick__hint';
        hint.textContent = 'Bitte zuerst die ' + dim1Label() + ' wählen.';
        brow.appendChild(hint);
        return;
      }
      var gebaut = 0;
      sizeGrid.widths[curH].forEach(function (b) {
        var val = sizeGrid.val[curH][b];
        var da = sizeExistsForColor(color, val);
        var eigeneWahl = !!cur && curH === cur.h && b === cur.b;
        // Block 5: Breiten, die es in der gewählten Farbe nicht gibt, werden
        // ausgeblendet statt ausgegraut. Einzige Ausnahme ist die bereits
        // gewählte Breite bei kürzbaren Produkten: sie ist eine Messung am
        // Fenster und bleibt sichtbar, gesperrt und als eigene Wahl markiert.
        // Bei nicht kürzbaren Produkten führt kein Weg zu dieser Größe, dort
        // verschwindet auch sie, der Zwischenzustand nennt sie im Text.
        if (!da && !(eigeneWahl && kuerzbar)) return;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'kh-fsize kh-sizebtn';
        btn.setAttribute('data-kh-bbtn', '');
        btn.setAttribute('data-value', val);
        btn.textContent = b;
        btn.classList.toggle('is-active', eigeneWahl);
        btn.classList.toggle('kh-sizebtn--wahl', eigeneWahl && !da);
        btn.setAttribute('aria-pressed', eigeneWahl ? 'true' : 'false');
        btn.toggleAttribute('disabled', !da);
        btn.title = da ? curH + ' x ' + b + ' cm' : curH + ' x ' + b + ' cm gibt es nicht in ' + (color || 'dieser Farbe');
        brow.appendChild(btn);
        gebaut++;
      });
      // Block 7: die Farbe führt in dieser Höhe gar nichts, die Reihe wäre
      // leer. An ihre Stelle tritt die Antwort mit den Höhen dieser Farbe als
      // anklickbare Vorschläge, dasselbe Muster wie Baustein 1 auf der
      // anderen Achse. Die Höhe wechselt dabei nie von selbst, erst der
      // Klick des Kunden setzt sie. Ist bereits eine Breite gewählt, erklärt
      // der Zwischenzustand darunter ausführlich, dann bleibt der Satz hier
      // kurz und ohne eigene Vorschläge, damit sich nichts doppelt.
      if (!gebaut) {
        var satzLeer = document.createElement('span');
        satzLeer.className = 'kh-sizepick__hint';
        satzLeer.textContent = (color || 'Diese Farbe') + ' gibt es nicht in ' + dim1Label() + ' ' + curH + ' cm.';
        brow.appendChild(satzLeer);
        if (!cur) {
          var andere = sizeGrid.heights.filter(function (h) {
            return h !== curH && heightExistsForColor(color, h);
          });
          andere.forEach(function (h) {
            var hb = document.createElement('button');
            hb.type = 'button';
            hb.className = 'kh-fsize kh-sizebtn';
            hb.setAttribute('data-kh-hwahl', String(h));
            hb.textContent = dim1Label() + ' ' + h + ' cm';
            brow.appendChild(hb);
          });
        }
      }
    }

    function renderSizeButtons() {
      sizeGrid = buildSizeGrid();
      if (!sizeGrid || !sizepick || !hrow || !brow || !sizeSelect) return;
      hrow.innerHTML = '';
      sizeGrid.heights.forEach(function (h) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'kh-fsize kh-sizebtn';
        btn.setAttribute('data-kh-hbtn', String(h));
        btn.textContent = h;
        hrow.appendChild(btn);
      });
      sizepick.hidden = false;
      var wrap = qs('[data-kh-size-wrap]', root);
      var lbl = qs('[data-kh-size-label]', root);
      if (wrap) wrap.style.display = 'none';
      if (lbl) lbl.style.display = 'none';
      sizeSelect.setAttribute('tabindex', '-1');
      sizeSelect.setAttribute('aria-hidden', 'true');
      sizepick.addEventListener('click', function (e) {
        var hb = e.target.closest('[data-kh-hbtn]');
        if (hb && !hb.disabled) {
          var h = +hb.getAttribute('data-kh-hbtn');
          var color = getColor();
          var cur = currentSizeParsed();
          // Solange keine Größe gewählt ist, merkt der Höhenklick nur die Höhe
          // vor und öffnet die Breitenreihe. Erst der Breitenklick wählt.
          if (!cur) {
            pendingH = h;
            syncSizeButtons();
            // Backlog 24: die Farbfelder hängen jetzt auch an der vorgemerkten
            // Höhe, deshalb müssen sie hier mitgezogen werden.
            refreshSwatches();
            update();
            return;
          }
          var gleiche = sizeGrid.val[h][cur.b];
          if (gleiche && sizeExistsForColor(color, gleiche)) {
            // Die gewählte Breite gibt es auch in der neuen Höhe. Nur die
            // Höhe wechselt, die Breite bleibt stehen.
            applySizeValue(gleiche);
            return;
          }
          // Backlog 14: die gewählte Breite gibt es in dieser Höhe nicht.
          // Früher wurde hier still die erste lieferbare Breite gesetzt. Der
          // Kunde klickte auf eine Höhe und bekam eine andere Breite und einen
          // anderen Preis, ohne jeden Hinweis. Stille Automatiken haben in
          // diesem Shop bereits eine Fehlbestellung gekostet, die Größe ist
          // eine Messung am Fenster und kein Wunsch.
          // Es wird deshalb keine Breite untergeschoben. Die Höhe wird nur
          // vorgemerkt und die Breitenreihe geöffnet, also genau der Zustand
          // wie bei einem Höhenklick ohne gewählte Größe ein paar Zeilen
          // weiter oben. Den Rest wählt der Kunde selbst, der Kaufhinweis
          // sagt dann "Bitte Breite wählen".
          pendingH = h;
          if (sizeSelect && sizeSelect.value !== '') {
            sizeSelect.value = '';
            sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            syncSizeButtons();
            refreshSwatches();
            update();
          }
          return;
        }
        var bb = e.target.closest('[data-kh-bbtn]');
        if (bb && !bb.disabled) { applySizeValue(bb.getAttribute('data-value')); return; }
        // Block 7: Höhen-Vorschlag aus der leeren Breitenreihe. Wirkt wie ein
        // Klick auf den Höhen-Knopf ohne gewählte Größe: Höhe vormerken,
        // Breitenreihe öffnen, gewählt ist damit noch nichts.
        var hw = e.target.closest('[data-kh-hwahl]');
        if (hw) {
          pendingH = +hw.getAttribute('data-kh-hwahl');
          syncSizeButtons();
          refreshSwatches();
          update();
        }
      });
      syncSizeButtons();
    }

    function sortSizeOptions() {
      if (!sizeSelect) return;
      // Die leere Platzhalter-Option bleibt vorn, sortiert werden nur echte Größen.
      var parsed = qsa('option', sizeSelect).filter(function (o) { return o.value !== ''; }).map(function (o) {
        var m = /^(\d+(?:[.,]\d+)?)x(\d+(?:[.,]\d+)?)cm$/i.exec(o.value);
        return { el: o, h: m ? parseFloat(m[1].replace(',', '.')) : 1e9, b: m ? parseFloat(m[2].replace(',', '.')) : 1e9 };
      });
      parsed.sort(function (a, b) { return a.h - b.h || a.b - b.b; });
      parsed.forEach(function (p) { p.el.textContent = prettySize(p.el.value); sizeSelect.appendChild(p.el); });
    }

    function refreshSizes() {
      if (!sizeSelect || sizeOptIndex < 0) return;
      var color = getColor();
      var existing = {};
      variants.forEach(function (v) {
        if (colorOptIndex < 0 || !color || v.options[colorOptIndex] === color) existing[v.options[sizeOptIndex]] = true;
      });
      qsa('option', sizeSelect).forEach(function (o) {
        if (o.value === '') return;
        var ok = !!existing[o.value];
        o.hidden = !ok;
        o.disabled = !ok;
      });
      // Baustein 1: die Größe ist eine Messung am Fenster und wechselt nie von
      // selbst. Führt die neue Farbe die gewählte Größe nicht, bleibt der Wert
      // stehen, und der Zwischenzustand erklärt es mit Vorschlägen.
      syncSizeButtons();
    }

    function refreshSwatches() {
      if (!swatchWrap || colorOptIndex < 0) return;
      var size = getSize();
      qsa('.kh-swatch', swatchWrap).forEach(function (sw) {
        var val = sw.getAttribute('data-value');
        var ok = colorAvailable(val, size);
        // Baustein 1: gesperrte Felder bleiben sichtbar gesperrt, sind aber
        // klickbar. Die Farbe ist ein Wunsch und darf gewinnen, den Rest
        // erklärt der Zwischenzustand. Ein stilles Umspringen der Farbe gibt
        // es nicht mehr, auch nicht als Reparatur.
        // Backlog 24: ist noch keine vollständige Größe gewählt, wohl aber
        // schon eine Höhe, dann zählt die Höhe. Eine Farbe, die in dieser Höhe
        // gar nichts führt, wird bereits vor dem Klick als gesperrt gezeigt.
        // Vorher sah sie aus wie jede andere, und der Kunde erfuhr es erst,
        // nachdem er sie angeklickt hatte. Das Feld bleibt klickbar, die Farbe
        // ist ein Wunsch und darf gewinnen, siehe Baustein 1.
        var heightHint = '';
        if (ok && !size && pendingH !== null && sizeOptIndex >= 0 && sizeGrid
            && !heightExistsForColor(val, pendingH)) {
          ok = false;
          heightHint = ', in ' + dim1Label() + ' ' + pendingH + ' cm nicht lieferbar.';
        }
        sw.classList.toggle('kh-swatch--off', !ok);
        // Am Farbfeld steht, welche Größen es in dieser Farbe gibt, immer
        // ausgeschrieben und nach Höhe gruppiert, nie nur eine Anzahl.
        var grText = sizeOptIndex >= 0 ? colorSizeText(val) : '';
        var titel = ok ? val + '.' + grText
                       : val + (heightHint || ', in dieser Größe nicht lieferbar.') + grText;
        sw.setAttribute('title', titel);
        sw.setAttribute('aria-label', 'Farbe ' + titel);
      });
    }

    function selectColor(swatchEl, silent) {
      qsa('.kh-swatch', swatchWrap).forEach(function (s) { s.setAttribute('aria-pressed', s === swatchEl ? 'true' : 'false'); });
      var color = swatchEl.getAttribute('data-value');
      if (swatchLabel) swatchLabel.textContent = color;
      refreshSizes();
      buildColorThumbs(color);
      // Der Musterblock hängt an der gewählten Farbe und braucht genau hier
      // Bescheid. selectColor ist die einzige Stelle, an der die Farbe
      // wechselt, deshalb sitzt die Meldung hier und nicht am Klick: der
      // Kollektionsfilter und die Rückwege rufen dieselbe Funktion.
      document.dispatchEvent(new CustomEvent('kh:farbe', { detail: { farbe: color } }));
      if (!silent) update();
    }

    function setActiveThumb(idx) {
      ['desktop', 'mobile'].forEach(function (key) {
        var blockEl = galleryBlocks[key];
        if (!blockEl) return;
        qsa('.kh-gallery__thumb', blockEl).forEach(function (t, i) {
          t.classList.toggle('is-active', i === idx);
        });
      });
    }

    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('.kh-gallery__thumb');
      if (thumb && root.contains(thumb)) {
        var img = thumb.querySelector('img');
        if (img && mainImg) {
          mainImg.src = img.getAttribute('data-full') || img.src;
          mainImg.srcset = '';
        }
        var blockEl = thumb.parentElement;
        var idx = qsa('.kh-gallery__thumb', blockEl).indexOf(thumb);
        setActiveThumb(idx);
      }
      var sw = e.target.closest('.kh-swatch');
      if (sw && swatchWrap && swatchWrap.contains(sw)) {
        // Baustein 1: jeder Klick auf ein gesperrtes Feld ist zugleich eine
        // gemessene Nachfrage nach einer Kombination, die es nicht gibt.
        // kh_quelle kennt genau zwei Werte: "pdp" für den Klick des Kunden,
        // "filter" für die Ankunft über kh-color/kh-size aus der Kollektion.
        // Das Flag setzt der Parameter-Empfänger im Produkttemplate.
        if (sw.classList.contains('kh-swatch--off') && getSize() && typeof window.gtag === 'function') {
          window.gtag('event', 'color_gap_click', {
            kh_product_id: root.getAttribute('data-handle') || '',
            kh_color: sw.getAttribute('data-value'),
            kh_size: prettySize(getSize()),
            kh_quelle: window.__khQuelleFilter ? 'filter' : 'pdp'
          });
        }
        selectColor(sw, false);
      }
    });

    if (sizeSelect) {
      sizeSelect.addEventListener('change', function () {
        refreshSwatches();
        syncSizeButtons();
        update();
      });
    }

    buildColorThumbs(getColor());

    // Lagerzeile. Zwei Stufen: sofort aus der Variantenmatrix, damit beim Umschalten
    // nichts stehenbleibt, danach der echte Bestand aus der Section kh-lagerstand.
    // Die Matrix ist ein nächtlicher Abzug, die Zahl darf nicht aus ihr stammen,
    // wenn jemand danach entscheidet, ob er mehrere Stück bestellen kann.
    var lagerSektion = null;
    var lagerLauf = 0;
    var lagerAbbruch = null;
    var lagerTimer = null;

    function sektionId() {
      if (lagerSektion !== null) return lagerSektion;
      var el = document.querySelector('[data-kh-lagerstand]');
      var wrap = el && el.closest('.shopify-section');
      lagerSektion = wrap ? wrap.id.replace(/^shopify-section-/, '') : '';
      return lagerSektion;
    }

    // Obergrenze der Mengenwahl auf den Bestand setzen, abzüglich dessen, was
    // von dieser Variante schon im Warenkorb liegt. Ohne Bestandsverfolgung
    // bleibt es bei 99. Der Wert aus der Variantenmatrix ist ein Abzug und kann
    // veraltet sein, deshalb überschreibt ihn kurz darauf der Live-Wert aus
    // der nachgeladenen Lagerzeile.
    function setzeMengengrenze(menge, tracked) {
      var box = qs('.kh-qty', root);
      var input = box && box.querySelector('.kh-qty__value');
      if (!box || !input) return;
      var grenze = 99;
      var drin = 0;
      if (tracked && typeof menge === 'number' && !isNaN(menge)) {
        drin = mengeImWarenkorb(idInput && idInput.value);
        grenze = Math.max(0, menge - drin);
      }
      input.setAttribute('data-max', String(grenze));
      input.setAttribute('data-grund', drin > 0 ? 'warenkorb' : 'lager');
      input.setAttribute('data-bestand', tracked && typeof menge === 'number' ? String(menge) : '');
      var val = parseInt(input.value, 10) || 1;
      stepperSetzen(box, Math.min(val, Math.max(1, grenze)), false);
      if (grenze <= 0) {
        atcBtns.forEach(function (b) { b.setAttribute('disabled', 'disabled'); });
        zeigeMengenhinweis(box, 0, drin > 0 ? 'warenkorb' : 'lager', menge);
      }
    }

    function grenzeAusLagerzeile(el) {
      if (!el) return;
      var roh = el.getAttribute('data-qty');
      var tracked = el.getAttribute('data-tracked') === '1' && roh !== null && roh !== '';
      setzeMengengrenze(tracked ? parseInt(roh, 10) : null, tracked);
    }

    function setStock(v, available) {
      if (!stockEl) return;
      setzeMengengrenze(v && typeof v.qty === 'number' ? v.qty : null, !!(v && typeof v.qty === 'number'));
      if (!available) {
        stockEl.className = 'kh-stock kh-stock--off';
        stockEl.innerHTML = stockEl.getAttribute('data-msg-off') || '';
        return;
      }
      var thr = parseInt(stockEl.getAttribute('data-low-threshold'), 10);
      var q = (v && typeof v.qty === 'number') ? v.qty : null;
      if (thr > 0 && q !== null && q > 0 && q <= thr) {
        stockEl.className = 'kh-stock kh-stock--low';
        stockEl.innerHTML = q === 1
          ? (stockEl.getAttribute('data-msg-one') || '')
          : (stockEl.getAttribute('data-msg-low') || '').replace('{menge}', q);
        return;
      }
      stockEl.className = 'kh-stock';
      stockEl.innerHTML = stockEl.getAttribute('data-msg-ok') || '';
    }

    function ladeLagerstand(v) {
      if (!stockEl || !v || !v.id) return;
      var sid = sektionId();
      if (!sid || typeof fetch !== 'function') return;
      if (lagerTimer) clearTimeout(lagerTimer);
      lagerTimer = setTimeout(function () {
        if (lagerAbbruch) { try { lagerAbbruch.abort(); } catch (e) {} }
        lagerAbbruch = (typeof AbortController === 'function') ? new AbortController() : null;
        var lauf = ++lagerLauf;
        var url = location.pathname + '?variant=' + encodeURIComponent(v.id) +
                  '&section_id=' + encodeURIComponent(sid);
        fetch(url, lagerAbbruch ? { signal: lagerAbbruch.signal } : undefined)
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (html) {
            // Nur übernehmen, wenn inzwischen keine neuere Auswahl kam.
            if (!html || lauf !== lagerLauf || !stockEl) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var frisch = doc.querySelector('[data-kh-stock]');
            if (!frisch) return;
            stockEl.className = frisch.className;
            stockEl.innerHTML = frisch.innerHTML;
            stockEl.setAttribute('data-qty', frisch.getAttribute('data-qty') || '');
            stockEl.setAttribute('data-tracked', frisch.getAttribute('data-tracked') || '0');
            grenzeAusLagerzeile(frisch);
          })
          .catch(function () { /* Netz weg oder abgebrochen: die Sofortanzeige bleibt stehen */ });
      }, 180);
    }

    var buyHint = qs('[data-kh-buy-hint]', root);
    var stockWrap = qs('[data-kh-stock-wrap]', root);
    var minPreis = variants.reduce(function (m, v) { return v.price < m ? v.price : m; }, Infinity);

    /* Block 8: Rotstift ohne Vorauswahl. Bezugspunkt ist die günstigste
       Variante, dieselbe wie beim Ab-Preis, damit "ab X statt Y" nie zwei
       Varianten vermischt. Ist sie selbst nicht reduziert, gibt es keinen
       Ab-Streichpreis, auch wenn andere Varianten reduziert sind. Das Badge
       ist eine Produktaussage: es erscheint nur, wenn alle Varianten
       reduziert sind, mit dem kleinsten gerundeten Satz. */
    var minVar = variants.reduce(function (m, v) { return (!m || v.price < m.price) ? v : m; }, null);
    var abCompare = (minVar && minVar.compare_at_price && minVar.compare_at_price > minVar.price) ? minVar.compare_at_price : null;
    var saleBadgePct = (function () {
      if (!variants.length) return null;
      var kleinster = null;
      for (var i = 0; i < variants.length; i++) {
        var sv = variants[i];
        if (!sv.compare_at_price || sv.compare_at_price <= sv.price) return null;
        var pct = Math.floor((sv.compare_at_price - sv.price) * 100 / sv.compare_at_price); // abrunden wie die Kachel in Liquid, nie mehr Rabatt ausweisen als gewährt
        if (kleinster === null || pct < kleinster) kleinster = pct;
      }
      return kleinster > 0 ? kleinster : null;
    })();

    // Hinweis am gesperrten Kaufen-Knopf: benennt, was noch fehlt.
    function fillBuyHint(v) {
      if (!buyHint) return;
      if (v) { buyHint.hidden = true; return; }
      // Zwischenzustand aus Baustein 1: beides ist gewählt, die Kombination
      // existiert nicht. Der Knopf nennt denselben Grund wie der Hinweis
      // unter der Größenauswahl, nicht den allgemeinen Satz aus Phase 2.
      var zColor = getColor();
      var zSize = getSize();
      if (zColor && zSize && sizeOptIndex >= 0 && !sizeExistsForColor(zColor, zSize)) {
        buyHint.textContent = zColor + ' gibt es nicht in ' + prettySize(zSize) + '.';
        buyHint.hidden = false;
        return;
      }
      var fehlt = [];
      if (colorOptIndex >= 0 && !getColor()) fehlt.push('Farbe');
      if (sizeOptIndex >= 0 && !currentSizeParsed()) {
        if (pendingH !== null) { fehlt.push(dim2Label()); }
        else { fehlt.push(dim1Label()); fehlt.push(dim2Label()); }
      }
      if (!fehlt.length) { buyHint.hidden = true; return; }
      var text = fehlt.length === 1 ? fehlt[0] : fehlt.slice(0, -1).join(', ') + ' und ' + fehlt[fehlt.length - 1];
      buyHint.textContent = 'Bitte ' + text + ' wählen.';
      buyHint.hidden = false;
    }

    function update() {
      var v = variantFor(getColor(), getSize());
      var available = !!(v && v.available);
      // Beide Formulare, Kaufbox und Sticky-Leiste, tragen ein eigenes Feld.
      // Bis zum 23.08. wurde nur das erste gefüllt, deshalb war der Knopf in
      // der Sticky-Leiste ohne Wirkung.
      for (var iIdx = 0; iIdx < idInputs.length; iIdx++) {
        idInputs[iIdx].value = v ? v.id : '';
      }
      // Ohne vollständige Wahl bleibt der Ab-Preis stehen, wie auf der Kachel,
      // seit Block 8 samt Ab-Streichpreis der günstigsten Variante.
      var pb = preisBild(v);
      if (!v && priceEl && isFinite(pb.preis)) {
        var abWert = priceEl.querySelector('.kh-price__value');
        if (abWert) abWert.textContent = formatEuro(pb.preis);
        var abVon = priceEl.querySelector('.kh-price__from');
        if (abVon) abVon.style.display = pb.ab ? '' : 'none';
        priceEl.classList.toggle('kh-price--sale', !!pb.cmp);
        var abCmp = priceEl.querySelector('.kh-price__compare');
        if (abCmp) {
          abCmp.textContent = pb.cmp ? formatEuro(pb.cmp) : '';
          abCmp.style.display = pb.cmp ? '' : 'none';
        }
      }
      // Block 9: das Rabatt-Badge sitzt dauerhaft am Produktbild. Ohne
      // Variante der kleinste gerundete Satz über alle (Block 8 Regel 2),
      // mit Variante ihr eigener Satz, unreduzierte Wahl blendet es aus,
      // auch wenn andere Varianten reduziert sind.
      var galleryBadge = qs('[data-kh-sale-badge]', root);
      if (galleryBadge) {
        var badgePct = null;
        if (v) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            badgePct = Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price); // abrunden wie die Kachel in Liquid, nie mehr Rabatt ausweisen als gewährt
          }
        } else {
          badgePct = saleBadgePct;
        }
        galleryBadge.hidden = badgePct === null;
        galleryBadge.textContent = badgePct !== null ? '-' + badgePct + '%' : '';
      }
      if (v && priceEl) {
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        priceEl.classList.toggle('kh-price--sale', !!onSale);
        var valEl = priceEl.querySelector('.kh-price__value');
        if (valEl) valEl.textContent = formatEuro(v.price);
        var cmpEl = priceEl.querySelector('.kh-price__compare');
        if (cmpEl) {
          cmpEl.textContent = onSale ? formatEuro(v.compare_at_price) : '';
          cmpEl.style.display = onSale ? '' : 'none';
        }
        var fromEl = priceEl.querySelector('.kh-price__from');
        if (fromEl) fromEl.style.display = 'none';
      }
      var inlineWrap = qs('[data-kh-inline-price]', root);
      if (inlineWrap) {
        inlineWrap.hidden = !v;
        if (v) {
          var ivp = inlineWrap.querySelector('.kh-price__value');
          if (ivp) ivp.textContent = formatEuro(v.price);
          // Block 9: auch "Ihr Preis" trägt den Streichpreis der Variante.
          var iOn = v.compare_at_price && v.compare_at_price > v.price;
          var iPrice = inlineWrap.querySelector('.kh-price');
          if (iPrice) iPrice.classList.toggle('kh-price--sale', !!iOn);
          var iCmp = inlineWrap.querySelector('.kh-price__compare');
          if (iCmp) {
            iCmp.textContent = iOn ? formatEuro(v.compare_at_price) : '';
            iCmp.style.display = iOn ? '' : 'none';
          }
        }
      }
      if (stockEl) {
        if (stockWrap) stockWrap.hidden = !v;
        if (v) {
          setStock(v, available);
          ladeLagerstand(v);
        }
      }
      fillBuyHint(v);
      renderMismatch();
      // Steht nur die Farbvorwahl, gibt es nichts zurückzusetzen.
      if (resetBtn) resetBtn.hidden = !(getColor() || getSize() || pendingH !== null) || istStartzustand();
      atcBtns.forEach(function (b) { b.toggleAttribute('disabled', !available); });
      if (satc) {
        var variantLabel = qs('[data-kh-satc-variant]', satc);
        var color = getColor();
        var size = getSize();
        var sizePretty = prettySize(size);
        if (variantLabel) variantLabel.textContent = [color, sizePretty].filter(Boolean).join(' · ');
        // Backlog 44: die Namenszeile trägt nur den Produktnamen. Die Farbe
        // steht eine Zeile darunter zusammen mit der Größe, vorher stand sie
        // an beiden Stellen und die Leiste las "PRATO · Weiß / Weiß · 130 x 60 cm".
        var satcName = qs('[data-kh-satc-name]', satc);
        if (satcName) satcName.textContent = satcName.getAttribute('data-base');
        var satcImg = qs('.kh-satc__img', satc);
        var ci = imageForColor(color);
        if (satcImg && ci) satcImg.src = ci;
        var satcPrices = qsa('[data-kh-satc-price]', satc);
        satcPrices.forEach(function (p) {
          var vp = p.querySelector('.kh-price__value');
          var fr = p.querySelector('.kh-price__from');
          var cp = p.querySelector('.kh-price__compare');
          // Ohne Variante bleibt auch hier der Ab-Preis stehen, seit Block 8
          // mit dem Ab-Streichpreis der günstigsten Variante. Mit Variante
          // zeigt die Leiste wie bisher nur den konkreten Preis.
          if (v) {
            if (vp) vp.textContent = formatEuro(v.price);
            if (fr) fr.style.display = 'none';
            // Block 9: auch die Sticky-Leiste zeigt den Streichpreis der
            // gewählten Variante, nicht mehr nur den Ab-Zustand.
            var sOn = v.compare_at_price && v.compare_at_price > v.price;
            p.classList.toggle('kh-price--sale', !!sOn);
            if (cp) {
              cp.textContent = sOn ? formatEuro(v.compare_at_price) : '';
              cp.style.display = sOn ? '' : 'none';
            }
          } else {
            if (vp && isFinite(pb.preis)) vp.textContent = formatEuro(pb.preis);
            if (fr) fr.style.display = pb.ab ? '' : 'none';
            p.classList.toggle('kh-price--sale', !!pb.cmp);
            if (cp) {
              cp.textContent = pb.cmp ? formatEuro(pb.cmp) : '';
              cp.style.display = pb.cmp ? '' : 'none';
            }
          }
        });
      }
      var evt = new CustomEvent('kh:variant', { bubbles: true, detail: { variant: v } });
      root.dispatchEvent(evt);
    }

    var qtyBox = qs('.kh-qty', root);
    var qtyHidden = qsa('input[name="quantity"]');
    if (qtyBox) {
      qtyBox.addEventListener('kh:qty', function (e) {
        qtyHidden.forEach(function (i) { i.value = e.detail.value; });
      });
    }

    // Beim Seitenaufruf einmal den Warenkorb lesen, damit die Grenze auch dann
    // stimmt, wenn von dieser Variante schon etwas drin liegt. Danach nach
    // jedem Hinzufügen neu rechnen.
    ladeWarenkorbstand().then(function () { grenzeAusLagerzeile(stockEl); });
    document.addEventListener('kh:warenkorb', function () { grenzeAusLagerzeile(stockEl); });

    if (satc && window.matchMedia('(min-width: 750px)').matches) {
      var onScroll = function () {
        satc.classList.toggle('is-visible', window.scrollY > 620);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    } else if (satc) {
      satc.classList.add('is-visible');
    }

    var massIn = qs('[data-kh-mass]', root);
    if (massIn) {
      var mirrors = qsa('[data-kh-mass-mirror]');
      massIn.addEventListener('input', function () {
        mirrors.forEach(function (m) { m.value = massIn.value; });
      });
      mirrors.forEach(function (m) {
        var mf = m.closest('form');
        if (mf) mf.addEventListener('submit', function (e) {
          if (!massIn.value.trim()) {
            e.preventDefault();
            massIn.focus();
            massIn.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        });
      });
    }

    /* Baustein 1: Zwischenzustand. Farbe und Größe sind gewählt, die
       Kombination existiert nicht. Die Größe bleibt stehen wie gemessen, die
       Seite bietet die Größen dieser Farbe als Knöpfe an, und der Rückweg
       stellt die letzte Farbe wieder her, in der die Kombination existierte.
       Erst ein Klick des Kunden ändert Größe oder Farbe. */
    var mismatchEl = qs('[data-kh-mismatch]', root);
    var lastValidColor = null;

    /* Baustein 3: Kürz-Hinweis. Nur wenn das Produkt gekürzt werden darf, die
       nächstgrößere Breite in dieser Farbe und Höhe existiert, lieferbar ist,
       höchstens 10 cm größer ausfällt und der Kürzservice weniger als die
       Hälfte des Variantenpreises kostet. Die Schwellen sind gesetzt, nicht
       gemessen, siehe Auftrag Phase 3. */
    var kuerzbar = root.getAttribute('data-kuerzbar') === '1';
    var kuerzPreis = parseInt(root.getAttribute('data-kuerz-preis'), 10) || 0;
    var kuerzUrl = root.getAttribute('data-kuerz-url') || '';
    var kuerzVariant = parseInt(root.getAttribute('data-kuerz-variant'), 10) || 0;

    function kuerzHinweis(color, size) {
      if (!kuerzbar || !kuerzPreis || sizeOptIndex < 0) return null;
      var m = /^(\d+)x(\d+)cm$/i.exec(size || '');
      if (!m) return null;
      var h = +m[1], b = +m[2];
      var beste = null;
      variants.forEach(function (v) {
        if (colorOptIndex >= 0 && v.options[colorOptIndex] !== color) return;
        if (!v.available) return;
        var vm = /^(\d+)x(\d+)cm$/i.exec(String(v.options[sizeOptIndex] || '').trim());
        if (!vm || +vm[1] !== h) return;
        var vb = +vm[2];
        if (vb <= b || vb - b > 10) return;
        if (kuerzPreis * 2 >= v.price) return;
        if (!beste || vb < beste.b2) beste = { val: v.options[sizeOptIndex], b2: vb, wunschB: b, id: v.id, preis: v.price, h: h };
      });
      return beste;
    }

    /* Block 6 Teil B: beide Positionen in einem Zug. Das Property des Service
       trägt den vollen Bezug, damit im Lager ohne Rückfrage klar ist, welches
       Plissee gemeint ist. _kh_fuer koppelt den Service an die Plissee-
       Variante, der Wächter räumt verwaiste Services darüber ab. Unterstrich-
       Properties blendet das Cart-Rendering aus. */
    function kuerzDirektAdd(kuerz, color, quelle) {
      if (!kuerzVariant || !kuerz) return Promise.resolve(false);
      var titelEl = qs('.kh-buybox__title');
      var kurzTitel = titelEl ? titelEl.textContent.trim().split(',')[0] : (root.getAttribute('data-handle') || '');
      var bezug = 'Für: ' + kurzTitel + ' ' + (color || '') + ' ' + prettySize(kuerz.val) +
        ', kürzen auf ' + kuerz.wunschB + ' cm Breite';
      var props = { 'Maß zu kürzen in cm': bezug };
      props['_kh_fuer'] = String(kuerz.id);
      return fetch(routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: kuerz.id, quantity: 1 },
            { id: kuerzVariant, quantity: 1, properties: props }
          ],
          sections: 'kh-cart-drawer'
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.status) {
            khMeldung(data.description || 'Das hat leider nicht geklappt.');
            return false;
          }
          if (data.sections && data.sections['kh-cart-drawer']) Drawer.replaceFromSectionHtml(data.sections['kh-cart-drawer']);
          return fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              updateCartCount(cart.item_count);
              Drawer.open();
              document.dispatchEvent(new CustomEvent('kh:warenkorb'));
              // Backlog 13: der Direkt-Add war bisher ungemessen, seine Nutzung
              // ließ sich damit nicht von der normalen Bestellung unterscheiden.
              // Gemeldet wird erst der erfolgreiche Lauf, ein abgelehnter
              // Warenkorb zählt nicht mit. Der Weg ist window.gtag, nicht
              // dataLayer, im Hauptdokument hört kein Container mit.
              // Die vier kh_-Parameter sind bereits als Dimensionen angelegt,
              // kh_kuerz_breite kommt neu dazu.
              if (typeof window.gtag === 'function') {
                window.gtag('event', 'kuerz_direkt_add', {
                  kh_product_id: root.getAttribute('data-handle') || '',
                  kh_color: color || '',
                  kh_size: prettySize(kuerz.val),
                  kh_kuerz_breite: kuerz.wunschB,
                  kh_quelle: quelle || 'pdp'
                });
              }
              return true;
            });
        })
        .catch(function () { khMeldung('Das hat leider nicht geklappt. Bitte versuchen Sie es noch einmal.'); return false; });
    }

    /* Backlog 3, Phase 1b, 23.08.2026. Kürzservice direkt von der Produktseite
       buchen, ohne Seitenwechsel.

       Warum das klein bleibt: der Kunde hat seine Breite bereits gewählt. Es
       muss nichts im Raster gesucht werden, es ist nur zu prüfen, ob die
       Wunschbreite höchstens 10 cm darunter liegt. Damit entfällt der ganze
       Suchteil, an dem die grosse Variante gescheitert wäre.

       Was hier bewusst NICHT passiert: die gewählte Breite wird nicht
       angefasst. Ein stiller Sprung in der Größenauswahl hat in diesem Shop
       bereits eine Fehlbestellung gekostet. Die Eingabe unten ist ein Wunsch
       an die Fertigung, keine zweite Größenwahl.

       KEINE PREISBREMSE, und das ist eine Entscheidung, keine Lücke.
       Entschieden von Fjodor am 23.08.2026, bitte nicht "reparieren".

       kuerzHinweis weiter oben lehnt einen Vorschlag ab, wenn der Service mehr
       als die Hälfte des Produktpreises kostet (kuerzPreis * 2 >= v.price).
       Dort ist das richtig: der Zwischenzustand schlägt die Kürzung ungefragt
       vor, und einen teuren Service zu einem billigen Behang aufzudrängen wäre
       schlechte Beratung.

       Hier liegt der Fall anders. Der Kunde klappt das Feld selbst auf und
       tippt sein Maß ein, das ist eine Anfrage und keine Empfehlung. Das
       Formular zeigt Plisseepreis, Servicepreis und Summe einzeln, das
       Verhältnis kann er selbst beurteilen.

       Gemessen am 23.08.2026: die beiden Wege unterscheiden sich auf 368 von
       1.335 Varianten der 14 kürzbaren Produkte, also 27,6 Prozent. Bei PISA
       sind es 195 von 460, bei stone 18 von 30, beim Wabenplissee keine
       einzige. Ob beide Wege angeglichen werden, wird entschieden, sobald
       kuerz_direkt_add zwei bis drei Wochen Daten hat. Bis dahin bleibt beides
       wie es ist. */
    (function initKuerzWunsch() {
      var box = qs('[data-kh-kuerzbox]', root);
      if (!box || !kuerzbar || !kuerzVariant) return;
      var schalter = qs('[data-kh-kuerz-auf]', box);
      var form = qs('[data-kh-kuerz-form]', box);
      var feld = qs('[data-kh-kuerz-eingabe]', box);
      var ergebnis = qs('[data-kh-kuerz-ergebnis]', box);
      var addBtn = qs('[data-kh-kuerz-wunsch-add]', box);
      if (!schalter || !form || !feld || !ergebnis || !addBtn) return;

      function gewaehlt() {
        var m = /^(\d+)x(\d+)cm$/i.exec(getSize() || '');
        if (!m) return null;
        return { h: +m[1], b: +m[2], val: getSize() };
      }

      function melde(text) {
        ergebnis.textContent = text;
        ergebnis.hidden = !text;
        addBtn.hidden = true;
        return null;
      }

      /* Gibt den Auftrag zurück, wenn die Eingabe gültig ist, sonst null.
         Nebenwirkung ist allein die Anzeige, nie die Größenauswahl. */
      function pruefe() {
        var g = gewaehlt();
        var farbe = getColor();
        var v = g ? variantFor(farbe, g.val) : null;
        if (!g || !v) return melde('Bitte wählen Sie zuerst Farbe und Breite, dann rechnen wir Ihnen das Kürzen aus.');
        if (!v.available) return melde('Diese Größe ist gerade nicht lieferbar.');
        var wunsch = parseInt(feld.value, 10);
        if (!isFinite(wunsch)) return melde('');
        var diff = g.b - wunsch;
        if (diff === 0) return melde('Das ist genau die gewählte Breite. Zum Kürzen geben Sie ein kleineres Maß an.');
        if (diff < 0) return melde('Wir können nur schmaler machen, nicht breiter. Ihre gewählte Breite ist ' + g.b + ' cm.');
        if (diff > 10) return melde('Wir kürzen höchstens 10 cm. Von ' + g.b + ' auf ' + wunsch + ' cm wären es ' + diff + ' cm. Wählen Sie oben bitte eine kleinere Standardbreite und rechnen Sie von dort.');

        ergebnis.hidden = false;
        ergebnis.textContent = '';
        var stark = document.createElement('strong');
        stark.textContent = g.b + ' cm bestellen, auf ' + wunsch + ' cm kürzen, zusammen ' + formatEuro(v.price + kuerzPreis);
        ergebnis.appendChild(stark);
        var teil = document.createElement('span');
        teil.className = 'kh-kuerzform__teilpreise';
        teil.textContent = 'Plissee ' + formatEuro(v.price) + ' plus Kürzservice ' + formatEuro(kuerzPreis);
        ergebnis.appendChild(teil);
        addBtn.textContent = 'Gekürzt auf ' + wunsch + ' cm in den Warenkorb';
        addBtn.hidden = false;
        return { id: v.id, val: g.val, wunschB: wunsch, preis: v.price };
      }

      function vorbelegen() {
        var g = gewaehlt();
        if (g && !feld.value) feld.value = g.b;
        if (g) { feld.max = g.b - 1; feld.min = Math.max(1, g.b - 10); }
      }

      schalter.addEventListener('click', function () {
        var auf = form.hidden;
        form.hidden = !auf;
        schalter.setAttribute('aria-expanded', auf ? 'true' : 'false');
        if (auf) { vorbelegen(); pruefe(); feld.focus(); }
      });

      feld.addEventListener('input', pruefe);
      /* Ändert der Kunde oben die Größe, wird neu vorbelegt und neu gerechnet.
         Der Weg geht nur in diese Richtung, nie zurück. */
      root.addEventListener('kh:variant', function () {
        if (form.hidden) return;
        var g = gewaehlt();
        if (g) feld.value = g.b;
        vorbelegen();
        pruefe();
      });

      addBtn.addEventListener('click', function () {
        var auftrag = pruefe();
        if (!auftrag) return;
        addBtn.disabled = true;
        kuerzDirektAdd(auftrag, getColor(), 'pdp_wunschmass').then(function (ok) {
          addBtn.disabled = false;
          if (ok) { form.hidden = true; schalter.setAttribute('aria-expanded', 'false'); }
        });
      });
    })();

    function renderMismatch() {
      if (!mismatchEl) return;
      var color = getColor();
      var size = getSize();
      var mismatch = !!(color && size && sizeOptIndex >= 0 && !sizeExistsForColor(color, size));
      if (color && size && !mismatch) lastValidColor = color;
      mismatchEl.hidden = !mismatch;
      mismatchEl.innerHTML = '';
      if (!mismatch) return;
      var satz = document.createElement('p');
      satz.className = 'kh-mismatch__satz';
      satz.textContent = color + ' gibt es nicht in ' + prettySize(size) + '. Lieferbar in dieser Farbe:';
      mismatchEl.appendChild(satz);
      var reihe = document.createElement('div');
      reihe.className = 'kh-mismatch__reihe';
      var info = colorSizeInfo(color);
      var curM = /^(\d+)x(\d+)cm$/i.exec(size || '');
      var curH2 = curM ? +curM[1] : null;
      var curB2 = curM ? +curM[2] : null;
      // Block 6 Teil A: Vorschläge nur in der gewählten Höhe. Wer 210 gemessen
      // hat, kann mit 130ern nichts anfangen. Führt die Farbe in dieser Höhe
      // gar nichts, fällt die Liste auf alle Größen der Farbe zurück, eine
      // leere Reihe hilft niemandem.
      var werte = info.flat || [];
      if (info.byHeight) {
        var gruppe = curH2 !== null ? info.byHeight.filter(function (g) { return g.h === curH2; }) : [];
        var quelle = gruppe.length ? gruppe : info.byHeight;
        werte = [];
        quelle.forEach(function (g) { werte = werte.concat(g.vals); });
      }
      // Über acht Vorschläge: die nächstliegenden um die gewünschte Breite,
      // der Rest hinter "alle anzeigen". Acht ist gesetzt, nicht gemessen.
      var alleKey = color + '|' + size;
      var zeigeAlle = mismatchEl.getAttribute('data-kh-alle') === alleKey;
      var gekappt = false;
      if (!zeigeAlle && werte.length > 8 && curB2 !== null) {
        var sortiert = werte.slice().sort(function (a, b) {
          var ab = +(/x(\d+)cm$/i.exec(a) || [0, 0])[1];
          var bb = +(/x(\d+)cm$/i.exec(b) || [0, 0])[1];
          return Math.abs(ab - curB2) - Math.abs(bb - curB2);
        }).slice(0, 8);
        werte = werte.filter(function (v) { return sortiert.indexOf(v) !== -1; });
        gekappt = true;
      }
      werte.forEach(function (val) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'kh-fsize kh-sizebtn kh-mismatch__btn';
        btn.setAttribute('data-kh-vorschlag', val);
        btn.textContent = prettySize(val);
        reihe.appendChild(btn);
      });
      if (gekappt) {
        var mehr = document.createElement('button');
        mehr.type = 'button';
        mehr.className = 'kh-mismatch__mehr';
        mehr.setAttribute('data-kh-alle-anzeigen', alleKey);
        mehr.textContent = 'alle anzeigen';
        reihe.appendChild(mehr);
      }
      mismatchEl.appendChild(reihe);
      var kuerz = kuerzHinweis(color, size);
      if (kuerz) {
        var tipp = document.createElement('p');
        tipp.className = 'kh-mismatch__kuerz';
        tipp.appendChild(document.createTextNode('Tipp: ' + prettySize(kuerz.val) + ' lässt sich passgenau auf ' + kuerz.wunschB + ' cm Breite kürzen. Beides zusammen ' + formatEuro(kuerz.preis + kuerzPreis) + ' (Plissee ' + formatEuro(kuerz.preis) + ' plus Kürzservice ' + formatEuro(kuerzPreis) + '). '));
        var link = document.createElement('a');
        link.href = kuerzUrl;
        link.target = '_blank';
        link.rel = 'noopener';
        link.textContent = 'Mehr zum Kürzservice';
        tipp.appendChild(link);
        mismatchEl.appendChild(tipp);
        var kaufBtn = document.createElement('button');
        kaufBtn.type = 'button';
        kaufBtn.className = 'kh-btn kh-btn--accent kh-mismatch__kuerzadd';
        kaufBtn.setAttribute('data-kh-kuerz-add', '');
        kaufBtn.textContent = 'Gekürzt auf ' + kuerz.wunschB + ' cm in den Warenkorb, ' + formatEuro(kuerz.preis + kuerzPreis);
        mismatchEl.appendChild(kaufBtn);
      }
      if (lastValidColor && lastValidColor !== color && sizeExistsForColor(lastValidColor, size)) {
        var back = document.createElement('button');
        back.type = 'button';
        back.className = 'kh-mismatch__zurueck';
        back.setAttribute('data-kh-zurueck', lastValidColor);
        back.textContent = 'Zurück zu ' + lastValidColor + ' in ' + prettySize(size) + '.';
        mismatchEl.appendChild(back);
      }
    }

    if (mismatchEl) {
      mismatchEl.addEventListener('click', function (e) {
        var vb = e.target.closest('[data-kh-vorschlag]');
        if (vb) { applySizeValue(vb.getAttribute('data-kh-vorschlag')); return; }
        var mehr = e.target.closest('[data-kh-alle-anzeigen]');
        if (mehr) {
          mismatchEl.setAttribute('data-kh-alle', mehr.getAttribute('data-kh-alle-anzeigen'));
          renderMismatch();
          return;
        }
        var ka = e.target.closest('[data-kh-kuerz-add]');
        if (ka) {
          var kz = kuerzHinweis(getColor(), getSize());
          if (!kz) return;
          ka.disabled = true;
          kuerzDirektAdd(kz, getColor()).then(function () { ka.disabled = false; });
          return;
        }
        var zb = e.target.closest('[data-kh-zurueck]');
        if (zb) {
          var alt = zb.getAttribute('data-kh-zurueck');
          var btn = swatchWrap ? qs('.kh-swatch[data-value="' + alt.replace(/"/g, '\\"') + '"]', swatchWrap) : null;
          if (btn) selectColor(btn, false);
        }
      });
    }

    /* Farbvorwahl beim Öffnen. Gilt nur, wenn die Section sie freigibt
       (Theme-Einstellung an, kein ?variant, Produkt mit Farbe) und die Adresse
       kein kh-color trägt. Vorgewählt wird nur die Farbe, die Größe bleibt eine
       Messung des Kunden und wird nie gesetzt. Die Wahl:
         1. eine Farbe am Produkt: diese;
         2. sonst die Farbe des Hauptbilds, wenn ihr kleinster lieferbarer Preis
            der kleinste lieferbare Preis des Produkts ist;
         3. sonst die Farbe der günstigsten lieferbaren Variante, bei Gleichstand
            Weiß, sonst die erste in der Reihenfolge der Farbfelder;
         4. ohne lieferbare Variante keine Vorwahl.
       Regel 2 und 3 halten den angezeigten Ab-Preis gleich dem Angebot im
       JSON-LD, das ohne ?variant die günstigste lieferbare Variante beschreibt.
       5. Kommt kh-size ohne kh-color (Ankunft aus dem Kollektionsfilter), greift
          die Vorwahl nur, wenn die Farbe diese Größe oder Höhe lieferbar führt.
          Sonst bliebe die Farbe stehen und die Größenübernahme würde sie still
          korrigieren (fixColor im Produkttemplate).
       Das Hauptbild wird über den Dateinamen ohne Größenendung erkannt, weil
       die Matrix und Liquid dieselbe Datei unter verschiedenen Adressen führen.
       Ermittelt wird aus KhProductData, nicht aus product.variants in Liquid,
       dort kappt Shopify bei 250 Varianten. */
    function bildSchluessel(u) {
      return u ? String(u).split('?')[0].split('/').pop().replace(/_\d+x\d*(\.\w+)$/i, '$1') : '';
    }
    function farbvorwahlErmitteln() {
      if (root.getAttribute('data-kh-farbvorwahl') !== '1') return null;
      if (!swatchWrap || colorOptIndex < 0) return null;
      if (/[?&]kh-color=/.test(window.location.search)) return null;
      var felder = qsa('.kh-swatch', swatchWrap).map(function (s) { return s.getAttribute('data-value'); });
      var lieferbar = variants.filter(function (v) { return v.available; });
      if (!felder.length || !lieferbar.length) return null;
      function minFarbe(c) {
        return lieferbar.reduce(function (m, v) {
          return v.options[colorOptIndex] === c && v.price < m ? v.price : m;
        }, Infinity);
      }
      var minProdukt = lieferbar.reduce(function (m, v) { return v.price < m ? v.price : m; }, Infinity);
      var wahl = null;
      if (felder.length === 1) {
        wahl = felder[0];
      } else {
        var hs = bildSchluessel(root.getAttribute('data-kh-hauptbild'));
        var hv = hs ? variants.find(function (v) { return v.image && bildSchluessel(v.image) === hs; }) : null;
        var hauptFarbe = hv ? hv.options[colorOptIndex] : null;
        if (hauptFarbe && felder.indexOf(hauptFarbe) !== -1 && minFarbe(hauptFarbe) === minProdukt) {
          wahl = hauptFarbe;
        } else {
          var guenstig = felder.filter(function (c) { return minFarbe(c) === minProdukt; });
          wahl = guenstig.indexOf('Weiß') !== -1 ? 'Weiß' : (guenstig[0] || null);
        }
      }
      var mS = /[?&]kh-size=([^&]+)/.exec(window.location.search);
      if (wahl && mS && sizeOptIndex >= 0) {
        var n = function (s) { return String(s == null ? '' : s).replace(/\s/g, '').toLowerCase(); };
        var want = n(decodeURIComponent(mS[1]));
        var nurH = /^(\d+)x$/.exec(want);
        var passt = lieferbar.some(function (v) {
          if (v.options[colorOptIndex] !== wahl) return false;
          var g = n(v.options[sizeOptIndex]);
          return nurH ? g.indexOf(nurH[1] + 'x') === 0 : g === want;
        });
        if (!passt) wahl = null;
      }
      return wahl;
    }
    var startFarbe = farbvorwahlErmitteln();
    function startFeld() {
      if (!startFarbe || !swatchWrap) return null;
      return qsa('.kh-swatch', swatchWrap).find(function (s) { return s.getAttribute('data-value') === startFarbe; }) || null;
    }
    function istStartzustand() {
      return !!startFarbe && getColor() === startFarbe && !getSize() && pendingH === null;
    }

    /* Baustein 4: allgemeiner Rückweg in den Einstieg. Mit Farbvorwahl ist das
       die vorgewählte Farbe ohne Größe, sonst der Einstieg ohne Vorauswahl.
       Das Hauptbild kehrt zum Ausgangsbild zurück, die Farb-Thumbnails
       bleiben stehen, sie sind Navigations- und kein Auswahlzustand. */
    var resetBtn = qs('[data-kh-auswahl-reset]', root);
    var mainImgOrig = mainImg ? { src: mainImg.getAttribute('src'), srcset: mainImg.getAttribute('srcset') } : null;

    function resetAuswahl() {
      if (swatchWrap) qsa('.kh-swatch', swatchWrap).forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
      if (swatchLabel) swatchLabel.textContent = 'bitte wählen';
      lastValidColor = null;
      pendingH = null;
      if (sizeSelect && sizeSelect.value !== '') sizeSelect.value = '';
      if (mainImg && mainImgOrig && mainImgOrig.src) {
        mainImg.src = mainImgOrig.src;
        if (mainImgOrig.srcset) mainImg.setAttribute('srcset', mainImgOrig.srcset);
      }
      refreshSizes();
      var sf = startFeld();
      if (sf) selectColor(sf, true);
      refreshSwatches();
      update();
    }
    if (resetBtn) resetBtn.addEventListener('click', resetAuswahl);

    sortSizeOptions();
    renderSizeButtons();
    refreshSizes();
    // Farbvorwahl still, wie ein Klick ohne Messung: selectColor löst kein
    // Tracking aus, color_gap_click hängt allein am Klick des Kunden.
    var sfStart = startFeld();
    if (sfStart) selectColor(sfStart, true);
    refreshSwatches();
    update();
  }

  /* ---------- Kategorie: Client-side Filter + Sortierung ---------- */
  function initCollection() {
    var root = qs('[data-kh-collection]');
    if (!root) return;
    var grid = qs('[data-kh-grid]', root);
    var cards = qsa('[data-kh-item]', grid);
    var countEl = qs('[data-kh-count]', root);
    var chipsWrap = qs('[data-kh-chips]', root);
    var emptyEl = qs('[data-kh-empty]', root);
    var totalCount = cards.length;

    var state = { types: [], colors: [], sizes: [], heights: [], price: null };
    var PRICE_BUCKETS = { 'p0-15': [0, 1500], 'p15-30': [1500, 3000], 'p30-': [3000, 99999900] };
    // Breiten-Buckets werden unten aus den echten Kartenwerten gebaut.
    // Schlüssel-Format: s<von>-<bis>, offenes Ende als s<von>-
    function parseSizeBucket(key) {
      var m = /^s(\d+)-(\d*)$/.exec(key || '');
      if (!m) return [0, 9999];
      return [parseInt(m[1], 10), m[2] ? parseInt(m[2], 10) : 9999];
    }

    function matches(card, s) {
      s = s || state;
      if (s.types.length) {
        var t = card.getAttribute('data-type') || '';
        if (s.types.indexOf(t) === -1) return false;
      }
      if (s.colors.length) {
        var cols = (card.getAttribute('data-colors') || '').split('||');
        var hit = s.colors.some(function (c) { return cols.indexOf(c) !== -1; });
        if (!hit) return false;
      }
      if (s.sizes.length) {
        var widths = (card.getAttribute('data-widths') || '').split(',').map(Number).filter(Boolean);
        var hitS = s.sizes.some(function (key) {
          var b = parseSizeBucket(key);
          return widths.some(function (w) { return w >= b[0] && w < b[1]; });
        });
        if (!hitS) return false;
      }
      if (s.heights.length) {
        var hs = (card.getAttribute('data-heights') || '').split(',').map(Number).filter(Boolean);
        var hitH = s.heights.some(function (h) { return hs.indexOf(+h) !== -1; });
        if (!hitH) return false;
      }
      if (s.price) {
        var p = parseInt(card.getAttribute('data-price') || '0', 10);
        var pb = PRICE_BUCKETS[s.price];
        if (!(p >= pb[0] && p < pb[1])) return false;
      }
      return true;
    }



    function sortColorSwatches() {
      // Logische Farb-Reihenfolge: Neutrale hell -> dunkel, dann Buntfarben entlang des Farbkreises.
      qsa('.kh-fcolors').forEach(function (wrap) {
        var btns = qsa('.kh-fcolor', wrap);
        if (btns.length < 3) { wrap.removeAttribute('data-kh-unsorted'); return; }
        function hslOf(btn) {
          var m = (getComputedStyle(btn).backgroundColor || '').match(/\d+(\.\d+)?/g);
          if (!m || m.length < 3) return [0, 0, 1];
          var r = m[0] / 255, g = m[1] / 255, b = m[2] / 255;
          var max = Math.max(r, g, b), min = Math.min(r, g, b);
          var l = (max + min) / 2, d = max - min;
          var s = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1));
          var h = 0;
          if (d) {
            if (max === r) h = ((g - b) / d + 6) % 6;
            else if (max === g) h = (b - r) / d + 2;
            else h = (r - g) / d + 4;
            h = h * 60;
          }
          return [h, s, l];
        }
        btns.map(function (b) {
          var x = hslOf(b);
          var neutral = x[1] < 0.10;
          // Neutrale zuerst (hell -> dunkel), dann Bunt ab den Erdtoenen entlang des Farbkreises, je Ton hell -> dunkel
          var key = neutral ? [0, 1 - x[2], 0] : [1, ((x[0] - 20 + 360) % 360) / 360, 1 - x[2]];
          return { b: b, k: key };
        }).sort(function (a, b) {
          for (var i = 0; i < 3; i++) { if (a.k[i] !== b.k[i]) return a.k[i] - b.k[i]; }
          return 0;
        }).forEach(function (item) { wrap.appendChild(item.b); });
        wrap.removeAttribute('data-kh-unsorted');
      });
    }

    function countWith(s) {
      var n = 0;
      cards.forEach(function (card) { if (matches(card, s)) n++; });
      return n;
    }

    function cloneState() {
      return { types: state.types.slice(), colors: state.colors.slice(), sizes: state.sizes.slice(), heights: state.heights.slice(), price: state.price };
    }

    function updateAvailability() {
      // Option ausgrauen, wenn sie als einzige Wahl ihrer Gruppe (bei sonst gleicher Auswahl) 0 Treffer ergibt.
      function probe(kind, value) {
        var s = cloneState();
        if (kind === 'price') { s.price = value; } else { s[kind + 's'] = [value]; }
        return countWith(s) > 0;
      }
      function setDis(el, disabled, isActive) {
        var off = disabled && !isActive;
        el.classList.toggle('is-disabled', off);
        if (el.tagName === 'BUTTON') el.disabled = off;
        if (el.tagName === 'INPUT') el.disabled = off;
      }
      qsa('[data-kh-ftype]', document).forEach(function (input) {
        setDis(input, !probe('type', input.value), state.types.indexOf(input.value) !== -1);
        var lbl = input.closest('label'); if (lbl) lbl.classList.toggle('is-disabled', input.disabled);
      });
      qsa('[data-kh-fcolor]', document).forEach(function (btn) {
        var v = btn.getAttribute('data-value');
        setDis(btn, !probe('color', v), state.colors.indexOf(v) !== -1);
      });
      qsa('[data-kh-fsize]', document).forEach(function (btn) {
        var v = btn.getAttribute('data-value');
        setDis(btn, !probe('size', v), state.sizes.indexOf(v) !== -1);
      });
      qsa('[data-kh-fheight]', document).forEach(function (btn) {
        var v = btn.getAttribute('data-value');
        setDis(btn, !probe('height', v), state.heights.indexOf(v) !== -1);
      });
      qsa('[data-kh-fprice]', document).forEach(function (input) {
        if (input.value === '') return;
        setDis(input, !probe('price', input.value), state.price === input.value);
        var lbl = input.closest('label'); if (lbl) lbl.classList.toggle('is-disabled', input.disabled);
      });
    }

    function labelFor(kind, value) {
      if (kind === 'price') {
        return { 'p0-15': 'bis 15 Euro', 'p15-30': '15 bis 30 Euro', 'p30-': 'ab 30 Euro' }[value] || value;
      }
      if (kind === 'size') {
        var sb = document.querySelector('[data-kh-fsize][data-value="' + value + '"]');
        return sb ? sb.textContent.trim() : value;
      }
      return value;
    }


    function cardMapOf(card) {
      if (card.__khMap !== undefined) return card.__khMap;
      var s = card.querySelector('[data-kh-cardmap]');
      try { card.__khMap = s ? JSON.parse(s.textContent) : null; } catch (e) { card.__khMap = null; }
      return card.__khMap;
    }

    /* Baustein 5: eindeutige Filterwerte an die Produktseite durchreichen.
       Nur genau eine gewählte Höhe wird übergeben, als "130x" über den
       Höhen-Knopf der Produktseite. Eine Breite kommt nur dazu, wenn genau
       ein Bereich aktiv ist, als kleinste Breite, die das Produkt in dieser
       Höhe darin führt. Bereiche sind Bereiche und keine Messung: alles
       Mehrdeutige übergibt nichts, ein falsch vorgewähltes Fenstermaß ist
       schlimmer als kein vorgewähltes. */
    function sizePassthrough(map) {
      if (state.heights.length !== 1 || !map || !map.s) return null;
      var h = Number(state.heights[0]);
      var inHeight = [];
      Object.keys(map.s).forEach(function (key) {
        var m = /^(\d+(?:[.,]\d+)?)x(\d+(?:[.,]\d+)?)cm$/.exec(key);
        if (!m || parseFloat(m[1].replace(',', '.')) !== h) return;
        inHeight.push({ w: parseFloat(m[2].replace(',', '.')), key: key });
      });
      if (!inHeight.length) return null;
      if (!state.sizes.length) return h + 'x';
      if (state.sizes.length !== 1) return null;
      var b = parseSizeBucket(state.sizes[0]);
      var drin = inHeight.filter(function (e) { return e.w >= b[0] && e.w < b[1]; });
      if (!drin.length) return null;
      drin.sort(function (x, y) { return x.w - y.w; });
      return drin[0].key;
    }

    function updateCardPreviews() {
      var hasColor = state.colors.length > 0;
      var hasHeights = state.heights.length > 0;
      var hasWidths = state.sizes.length > 0;
      var active = hasColor || hasHeights || hasWidths;
      var heightNums = state.heights.map(Number);
      cards.forEach(function (card) {
        var a = card.querySelector('a.kh-card');
        var img = card.querySelector('.kh-card__media img');
        var priceEl = card.querySelector('.kh-card__foot .kh-price__value');
        if (!a) return;
        if (!card.__khOrig) {
          card.__khOrig = {
            href: a.getAttribute('href'),
            src: img ? img.getAttribute('src') : null,
            srcset: img ? img.getAttribute('srcset') : null,
            price: priceEl ? priceEl.textContent : null
          };
        }
        function reset() {
          var o = card.__khOrig;
          if (a.getAttribute('href') !== o.href) a.setAttribute('href', o.href);
          if (img && o.src && img.getAttribute('src') !== o.src) {
            img.src = o.src;
            if (o.srcset) img.setAttribute('srcset', o.srcset);
          }
          if (priceEl && o.price !== null && priceEl.textContent !== o.price) priceEl.textContent = o.price;
        }
        var map = cardMapOf(card);
        if (!active || !map || card.classList.contains('kh-product-hidden')) { reset(); return; }

        var chosenColor = null;
        if (hasColor && map.c) {
          for (var i = 0; i < state.colors.length; i++) {
            if (map.c[state.colors[i]]) { chosenColor = state.colors[i]; break; }
          }
        }
        var sizeMin = null;
        if ((hasHeights || hasWidths) && map.s) {
          Object.keys(map.s).forEach(function (key) {
            var m = /^(\d+(?:[.,]\d+)?)x(\d+(?:[.,]\d+)?)cm$/.exec(key);
            if (!m) return;
            var h = parseFloat(m[1].replace(',', '.'));
            var w = parseFloat(m[2].replace(',', '.'));
            if (hasHeights && heightNums.indexOf(h) === -1) return;
            if (hasWidths) {
              var okW = state.sizes.some(function (k) { var b = parseSizeBucket(k); return w >= b[0] && w < b[1]; });
              if (!okW) return;
            }
            var e = map.s[key];
            if (sizeMin === null || e[0] < sizeMin) { sizeMin = e[0]; }
          });
        }

        var priceCents = null;
        if (chosenColor) {
          var ce = map.c[chosenColor];
          priceCents = ce[1];
          if (sizeMin !== null) priceCents = Math.max(priceCents, sizeMin);
          if (img && ce[2]) { img.src = ce[2]; img.removeAttribute('srcset'); }
        } else {
          if (img && card.__khOrig.src) {
            img.src = card.__khOrig.src;
            if (card.__khOrig.srcset) img.setAttribute('srcset', card.__khOrig.srcset);
          }
          if (sizeMin !== null) { priceCents = sizeMin; }
        }
        // Kachel-Links reichen nur durch, was der Kunde wirklich gewählt hat:
        // die Farbe aus dem Farbfilter, eindeutige Werte aus den Größenfiltern.
        // Ein ?variant= wäre eine Vorauswahl, die der Kunde nie getroffen hat,
        // und bleibt den Feed-Klicks vorbehalten.
        if (card.__khOrig.href) {
          var basis = card.__khOrig.href.split('?')[0];
          var params = [];
          if (chosenColor) params.push('kh-color=' + encodeURIComponent(chosenColor));
          var pass = sizePassthrough(map);
          if (pass) params.push('kh-size=' + encodeURIComponent(pass));
          a.setAttribute('href', params.length ? basis + '?' + params.join('&') : card.__khOrig.href);
        }
        if (priceEl) {
          priceEl.textContent = priceCents !== null ? formatEuro(priceCents) : card.__khOrig.price;
        }
      });
    }

    function apply() {
      var visible = 0;
      cards.forEach(function (card) {
        var ok = matches(card);
        card.classList.toggle('kh-product-hidden', !ok);
        if (ok) visible++;
      });
      if (countEl) countEl.textContent = visible + ' von ' + totalCount + ' Produkten';
      if (emptyEl) emptyEl.style.display = visible === 0 ? '' : 'none';
      updateCardPreviews();
      renderChips();
      var activeCount = state.types.length + state.colors.length + state.sizes.length + state.heights.length + (state.price ? 1 : 0);
      qsa('[data-kh-filter-count]').forEach(function (el) {
        el.textContent = activeCount > 0 ? ' (' + activeCount + ')' : '';
      });
      var resetBtns = qsa('[data-kh-reset]', root);
      resetBtns.forEach(function (b) { b.style.display = activeCount > 0 ? '' : 'none'; });
      updateAvailability();
    }

    function renderChips() {
      if (!chipsWrap) return;
      chipsWrap.innerHTML = '';
      var mk = function (label, kind, value) {
        var chip = document.createElement('span');
        chip.className = 'kh-chip';
        chip.textContent = label;
        var x = document.createElement('button');
        x.type = 'button';
        x.setAttribute('aria-label', label + ' entfernen');
        x.innerHTML = '<svg class="kh-icon" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>';
        x.addEventListener('click', function () { toggle(kind, value, false); syncInputs(); apply(); });
        chip.appendChild(x);
        chipsWrap.appendChild(chip);
      };
      state.types.forEach(function (t) { mk(t, 'type', t); });
      state.colors.forEach(function (c) { mk(c, 'color', c); });
      state.sizes.forEach(function (s) { mk(labelFor('size', s), 'size', s); });
      state.heights.forEach(function (h) { mk('Höhe ' + h + ' cm', 'height', h); });
      if (state.price) mk(labelFor('price', state.price), 'price', state.price);
      chipsWrap.style.display = chipsWrap.children.length ? '' : 'none';
    }

    function toggle(kind, value, forceOn) {
      if (kind === 'type' || kind === 'color' || kind === 'size' || kind === 'height') {
        var arr = state[kind + 's'];
        var i = arr.indexOf(value);
        var on = forceOn !== undefined ? forceOn : i === -1;
        if (on && i === -1) arr.push(value);
        if (!on && i !== -1) arr.splice(i, 1);
      } else if (kind === 'price') {
        state.price = (forceOn === false || state.price === value) && forceOn !== true ? null : value;
      }
    }

    function syncInputs() {
      qsa('[data-kh-ftype]', document).forEach(function (input) {
        input.checked = state.types.indexOf(input.value) !== -1;
      });
      qsa('[data-kh-fcolor]', document).forEach(function (btn) {
        btn.classList.toggle('is-active', state.colors.indexOf(btn.getAttribute('data-value')) !== -1);
      });
      qsa('[data-kh-fsize]', document).forEach(function (btn) {
        btn.classList.toggle('is-active', state.sizes.indexOf(btn.getAttribute('data-value')) !== -1);
      });
      qsa('[data-kh-fheight]', document).forEach(function (btn) {
        btn.classList.toggle('is-active', state.heights.indexOf(btn.getAttribute('data-value')) !== -1);
      });
      qsa('[data-kh-fprice]', document).forEach(function (input) {
        input.checked = state.price === input.value || (input.value === '' && !state.price);
      });
    }

    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-kh-ftype]')) { toggle('type', e.target.value, e.target.checked); apply(); }
      if (e.target.matches('[data-kh-fprice]')) { state.price = e.target.value || null; syncInputs(); apply(); }
    });
    document.addEventListener('click', function (e) {
      var cbtn = e.target.closest('[data-kh-fcolor]');
      if (cbtn) { toggle('color', cbtn.getAttribute('data-value')); syncInputs(); apply(); }
      var sbtn = e.target.closest('[data-kh-fsize]');
      if (sbtn) { toggle('size', sbtn.getAttribute('data-value')); syncInputs(); apply(); }
      var hbtn = e.target.closest('[data-kh-fheight]');
      if (hbtn) { toggle('height', hbtn.getAttribute('data-value')); syncInputs(); apply(); }
      var rbtn = e.target.closest('[data-kh-reset]');
      if (rbtn) {
        state.types = []; state.colors = []; state.sizes = []; state.heights = []; state.price = null;
        syncInputs(); apply();
      }
    });

    sortColorSwatches();

    var sortSelects = qsa('[data-kh-sort]');
    function sortCards(mode) {
      var wrappers = qsa('[data-kh-item]', grid);
      var sorted = wrappers.slice().sort(function (a, b) {
        if (mode === 'price-asc') return (+a.getAttribute('data-price')) - (+b.getAttribute('data-price'));
        if (mode === 'price-desc') return (+b.getAttribute('data-price')) - (+a.getAttribute('data-price'));
        if (mode === 'neu') return (+b.getAttribute('data-neu')) - (+a.getAttribute('data-neu')) || (+a.getAttribute('data-index')) - (+b.getAttribute('data-index'));
        return (+a.getAttribute('data-index')) - (+b.getAttribute('data-index'));
      });
      sorted.forEach(function (n) { grid.appendChild(n); });
    }
    sortSelects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        sortSelects.forEach(function (o) { o.value = sel.value; });
        sortCards(sel.value);
      });
    });

    var sheet = qs('#KhFilterSheet');
    if (sheet) {
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-kh-open-filter]')) { sheet.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
        if (e.target.closest('[data-kh-close-filter]') || (e.target.classList && e.target.classList.contains('kh-fsheet__overlay'))) {
          sheet.classList.remove('is-open'); document.documentElement.style.overflow = '';
        }
      });
    }

    // Breiten-Buttons dynamisch aus den Karten aufbauen. Wenige verschiedene Werte
    // ergeben Einzelbuttons, viele Werte drei Bereiche an gerundeten Dritteln.
    var allWidths = {};
    cards.forEach(function (card) {
      (card.getAttribute('data-widths') || '').split(',').map(Number).filter(Boolean).forEach(function (w) { allWidths[w] = true; });
    });
    var wVals = Object.keys(allWidths).map(Number).sort(function (a, b) { return a - b; });
    if (wVals.length > 1) {
      var round10 = function (n) { return Math.round(n / 10) * 10; };
      var buckets = [];
      if (wVals.length <= 6) {
        wVals.forEach(function (w) { buckets.push({ key: 's' + w + '-' + (w + 1), label: w + ' cm' }); });
      } else {
        var t1 = round10(wVals[Math.floor(wVals.length / 3)]);
        var t2 = round10(wVals[Math.floor(wVals.length * 2 / 3)]);
        if (t2 <= t1) t2 = t1 + 10;
        buckets = [
          { key: 's0-' + t1, label: 'bis ' + t1 + ' cm' },
          { key: 's' + t1 + '-' + t2, label: t1 + ' bis ' + t2 + ' cm' },
          { key: 's' + t2 + '-', label: 'ab ' + t2 + ' cm' }
        ];
      }
      qsa('[data-kh-fsizes]').forEach(function (wrap) {
        // Die Knöpfe kommen aus Liquid (kh-main-collection); gebaut wird nur, wenn dort nichts steht.
        if (wrap.querySelector('[data-kh-fsize]')) return;
        buckets.forEach(function (b) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'kh-fsize';
          btn.setAttribute('data-kh-fsize', '');
          btn.setAttribute('data-value', b.key);
          btn.textContent = b.label;
          wrap.appendChild(btn);
        });
        var grp = wrap.closest('[data-kh-sgroup]');
        if (grp) grp.hidden = false;
      });
    }

    // Höhen-Buttons dynamisch aus den Karten aufbauen
    var allHeights = {};
    cards.forEach(function (card) {
      (card.getAttribute('data-heights') || '').split(',').map(Number).filter(Boolean).forEach(function (h) { allHeights[h] = true; });
    });
    var hVals = Object.keys(allHeights).map(Number).sort(function (a, b) { return a - b; });
    if (hVals.length > 1) {
      qsa('[data-kh-fheights]').forEach(function (wrap) {
        if (wrap.querySelector('[data-kh-fheight]')) return;
        hVals.forEach(function (h) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'kh-fsize';
          b.setAttribute('data-kh-fheight', '');
          b.setAttribute('data-value', String(h));
          b.textContent = h + ' cm';
          wrap.appendChild(b);
        });
        var grp = wrap.closest('[data-kh-hgroup]');
        if (grp) grp.hidden = false;
      });
    }

    apply();
  }

  /* ---------- Trusted Shops Live-Badges ---------- */
  function initTsBadges() {
    var els = qsa('[data-kh-ts]');
    if (!els.length) return;
    var CH = 'chl-c8800d58-1c9b-4c27-b3ba-b500d151e2b7';
    function fmtNum(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
    function apply(d) {
      els.forEach(function (el) {
        var fill = el.querySelector('[data-kh-ts-fill]');
        if (fill) fill.style.width = (d.r / 5 * 100) + '%';
        var num = el.querySelector('[data-kh-ts-num]');
        if (num) num.textContent = d.r.toFixed(1).replace('.', ',') + ' / 5';
        var cnt = el.querySelector('[data-kh-ts-count]');
        if (cnt) cnt.textContent = fmtNum(d.c) + ' Bewertungen';
        el.hidden = false;
      });
    }
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem('khTsGrade') || 'null'); } catch (e) {}
    if (cached && cached.r) { apply(cached); return; }
    fetch('https://integrations.etrusted.com/feeds/grades/v1/channels/' + CH + '/touchpoints/all/feed.json')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var g = j && j.grades && (j.grades.overall || j.grades['365days']);
        if (!g || !g.rating) return;
        var d = { r: g.rating, c: g.count || 0 };
        try { sessionStorage.setItem('khTsGrade', JSON.stringify(d)); } catch (e) {}
        apply(d);
      }).catch(function () {});
  }
  initTsBadges();

  /* ---------- Cross-Selling via Shopify Recommendations ---------- */
  function initRecommendations() {
    var holder = qs('[data-kh-recommendations]');
    if (!holder) return;
    var url = holder.getAttribute('data-url');
    if (!url) return;
    /* Ohne Empfehlungen verschwindet die Section ganz, auch bei einem Abruffehler, sonst bliebe der für
       sie gehaltene Platz leer stehen. */
    function ausblenden() {
      var section = holder.closest('.shopify-section');
      if (section) section.style.display = 'none';
    }
    fetch(url)
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (text) {
        var tmp = document.createElement('div');
        tmp.innerHTML = text;
        var inner = tmp.querySelector('[data-kh-recommendations]');
        if (inner && inner.innerHTML.trim().length) {
          holder.innerHTML = inner.innerHTML;
        } else {
          ausblenden();
        }
      })
      .catch(ausblenden);
  }

  /* ---------- PDP: Montageanleitung direkt im Modal öffnen (D6b) ---------- */
  function initPdpMontage() {
    var teaser = qs('.kh-pdp-montage[data-kh-anleitung]');
    if (!teaser || !qs('[data-kh-pdp]')) return;
    var state = 'idle';
    teaser.addEventListener('click', function (e) {
      if (state === 'ready') return; /* kh-montage.js übernimmt ab jetzt */
      e.preventDefault();
      if (state === 'loading') return;
      state = 'loading';
      fetch('/pages/montageanleitungen')
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var modal = doc.getElementById('KhMontageModal');
          if (!modal) throw new Error('kein Modal');
          var cssHref = null, jsSrc = null;
          doc.querySelectorAll('link[rel="stylesheet"]').forEach(function (l) {
            if ((l.getAttribute('href') || '').indexOf('kh-montage') >= 0) cssHref = l.getAttribute('href');
          });
          doc.querySelectorAll('script[src]').forEach(function (s) {
            if ((s.getAttribute('src') || '').indexOf('kh-montage') >= 0) jsSrc = s.getAttribute('src');
          });
          if (!jsSrc) throw new Error('kein montage-js');
          document.body.appendChild(document.importNode(modal, true));
          function loadScript() {
            var script = document.createElement('script');
            script.src = jsSrc;
            script.onload = function () { state = 'ready'; teaser.click(); };
            script.onerror = function () { window.location.href = teaser.getAttribute('href'); };
            document.body.appendChild(script);
          }
          if (cssHref) {
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = cssHref;
            link.onload = loadScript;
            link.onerror = loadScript;
            document.head.appendChild(link);
          } else {
            loadScript();
          }
        })
        .catch(function () { window.location.href = teaser.getAttribute('href'); });
    });
  }

  /* ---------- Stoffmuster: Seite und Produktseiten-Block ---------- */
  /* Ein Handler für beide Flächen. Jeder Knopf, der ein Muster dazulegt,
     trägt data-kh-stm-add und seine Varianten-ID in data-id, egal ob er auf
     /pages/stoffmuster oder in der Buybox sitzt. Zwei getrennte Handler
     wären zwei Orte, an denen die Grenze von fünf gepflegt werden müsste. */
  function initStoffmuster() {
    var seite = qs('[data-kh-stoffmuster]');
    var pdpBlock = qs('[data-kh-musterblock]');
    if (!seite && !pdpBlock) return;

    /* --- Produktseite: die Mustervariante hängt an der gewählten Farbe --- */
    var musterMap = null;
    if (pdpBlock) {
      var mdEl = document.getElementById('KhMusterData');
      try { musterMap = mdEl ? JSON.parse(mdEl.textContent) : null; } catch (e) { musterMap = null; }
    }

    function pdpKnopf() { return pdpBlock && pdpBlock.querySelector('[data-kh-stm-add]'); }

    // Setzt den Knopf auf die aktuell gewählte Farbe. Ohne Farbe bleibt er
    // gesperrt und sagt, was fehlt: ein Knopf, der nichts tut und nicht sagt
    // warum, ist schlechter als keiner.
    function pdpAktualisieren() {
      if (!pdpBlock || !musterMap) return;
      var knopf = pdpKnopf();
      var hinweis = pdpBlock.querySelector('[data-kh-stm-pdp-hint]');
      if (!knopf) return;

      if (musterMap.karte) {
        knopf.setAttribute('data-id', String(musterMap.karte));
        knopf.setAttribute('data-farbe', 'Musterkarte');
        knopf.disabled = false;
      } else {
        var aktiv = qs('[data-kh-swatches] .kh-swatch[aria-pressed="true"]');
        var farbe = aktiv ? aktiv.getAttribute('data-value') : '';
        var vid = farbe && musterMap.farben ? musterMap.farben[farbe] : null;
        if (vid) {
          knopf.setAttribute('data-id', String(vid));
          knopf.setAttribute('data-farbe', farbe);
          knopf.disabled = false;
          if (hinweis) hinweis.textContent = 'Muster in ' + farbe + ', kostenlos und portofrei.';
        } else {
          knopf.removeAttribute('data-id');
          knopf.disabled = true;
          if (hinweis) {
            hinweis.textContent = farbe
              ? 'Für ' + farbe + ' gibt es derzeit kein Muster.'
              : 'Bitte wählen Sie zuerst eine Farbe.';
          }
        }
      }
      standAnzeigen(musterStand());
    }

    /* --- Beide Flächen: Stand anzeigen und Knöpfe sperren --- */
    function standAnzeigen(stand) {
      var grenze = musterGrenze();
      var voll = stand.anzahl >= grenze;

      if (seite) {
        var text = seite.querySelector('[data-kh-stm-text]');
        var hint = seite.querySelector('[data-kh-stm-hint]');
        var box = seite.querySelector('[data-kh-stm-zaehler]');
        if (text) {
          text.innerHTML = '<b>' + stand.anzahl + ' von ' + grenze + ' Mustern</b> liegen im Warenkorb.';
        }
        if (hint) {
          hint.textContent = voll
            ? 'Mehr gehen nicht in eine Bestellung. Nehmen Sie eines heraus, wenn Sie ein anderes möchten.'
            : 'Klicken Sie eine Farbe an, um sie dazuzulegen.';
        }
        if (box) box.setAttribute('data-voll', voll ? '1' : '0');
      }

      // Ein Knopf, dessen Muster schon im Warenkorb liegt, bleibt anklickbar
      // markiert und gesperrt: der Kunde soll sehen, was er gewählt hat.
      qsa('[data-kh-stm-add]').forEach(function (b) {
        var id = b.getAttribute('data-id');
        var drin = id && stand.ids[String(id)];
        b.setAttribute('aria-pressed', drin ? 'true' : 'false');
        if (b.hasAttribute('data-kh-stm-pdp')) return;
        b.disabled = !id || !!drin || voll;
      });

      var pk = pdpKnopf();
      if (pk && pk.getAttribute('data-id')) {
        var pdrin = !!stand.ids[String(pk.getAttribute('data-id'))];
        pk.disabled = pdrin || voll;
        var beschriftung = pk.querySelector('[data-kh-stm-label]');
        if (beschriftung) {
          // Der Normalzustand steht im Markup, nicht hier. Bei der Musterkarte
          // heisst er "Musterkarte dazulegen", und eine zweite Fassung im
          // Skript hat genau diese Unterscheidung am 21.09. überschrieben.
          var standard = pk.getAttribute('data-kh-stm-standard') || 'Kostenloses Stoffmuster dazulegen';
          beschriftung.textContent = pdrin
            ? 'Muster liegt im Warenkorb'
            : (voll ? 'Höchstens ' + grenze + ' Muster' : standard);
        }
      }
    }

    document.addEventListener('click', function (e) {
      var knopf = e.target.closest('[data-kh-stm-add]');
      if (!knopf || knopf.disabled) return;
      e.preventDefault();
      var id = knopf.getAttribute('data-id');
      if (!id) return;
      musterAdd(
        parseInt(id, 10),
        knopf.getAttribute('data-stoff') || '',
        knopf.getAttribute('data-farbe') || '',
        knopf.hasAttribute('data-kh-stm-pdp') ? 'pdp' : 'seite'
      );
    });

    document.addEventListener('kh:musterstand', function (e) { standAnzeigen(e.detail); });
    // Auch auf den allgemeinen Warenkorbwechsel hören: wer ein Muster im
    // Drawer wieder herausnimmt, muss die Knöpfe sofort zurückbekommen.
    //
    // Hier wird der Warenkorb NEU GELESEN und nicht aus khWarenkorb.zeilen
    // gerechnet. Der Unterschied ist der ganze Punkt: das Ereignis sagt, dass
    // sich etwas geändert hat, also ist der zwischengespeicherte Stand in
    // genau diesem Moment veraltet. Die erste Fassung rechnete aus dem alten
    // Stand und meldete nach dem Entfernen weiter 5 von 5.
    document.addEventListener('kh:warenkorb', function () {
      ladeWarenkorbstand().then(function () { standAnzeigen(musterStand()); });
    });
    if (pdpBlock) document.addEventListener('kh:farbe', pdpAktualisieren);

    ladeWarenkorbstand().then(function () {
      if (pdpBlock) pdpAktualisieren();
      standAnzeigen(musterStand());
    });
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    Drawer.init();
    initAtcForms();
    initSteppers();
    initHeader();
    initTabs();
    initAccordions();
    initPdp();
    initPdpMontage();
    initStoffmuster();
    initCollection();
    initRecommendations();
  });

  window.KhCartDrawer = Drawer;
})();

/* Tabs-Scroll-Affordance: Fade rechts, solange weitere Reiter verdeckt sind */
(function () {
  'use strict';
  function refresh(w, l) {
    var more = l.scrollWidth - l.clientWidth - l.scrollLeft > 8;
    w.classList.toggle('kh-tabscroll', more);
  }
  function init() {
    var wraps = document.querySelectorAll('[data-kh-tabs]');
    for (var i = 0; i < wraps.length; i++) {
      (function (w) {
        var l = w.querySelector('.kh-tabs__list');
        if (!l) return;
        refresh(w, l);
        l.addEventListener('scroll', function () { refresh(w, l); }, { passive: true });
        window.addEventListener('resize', function () { refresh(w, l); });
      })(wraps[i]);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Backlog 127: Info-Knöpfe an Höhe und Breite. Ein Tipp öffnet den Hinweis darunter,
   ein zweiter schließt ihn, Escape schließt alle. Funktioniert ohne Hover, also auch mobil. */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-kh-info]') : null;
    if (!b) return;
    var ziel = document.getElementById(b.getAttribute('aria-controls'));
    if (!ziel) return;
    var auf = b.getAttribute('aria-expanded') !== 'true';
    b.setAttribute('aria-expanded', auf ? 'true' : 'false');
    ziel.hidden = !auf;
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-kh-info][aria-expanded="true"]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
      var z = document.getElementById(b.getAttribute('aria-controls'));
      if (z) z.hidden = true;
    });
  });
})();
